/* eslint-disable react/jsx-pascal-case */
import React, { useState, useEffect } from "react";
import {
  Menu,
  Select,
  Space,
  Dropdown,
  Button,
  message,
  Radio,
  Tag,
  Row,
  Switch,
  Pagination,
  Input,
  Col,
  Typography,
  AutoComplete,
  Modal,
  Drawer,
  Checkbox,
} from "antd";
import { FiChevronDown } from 'react-icons/fi';
import {
  ApolloClient,
  InMemoryCache,
  ApolloProvider,
  useQuery,
  ApolloLink,
  gql,
  useLazyQuery,
} from "@apollo/client";
import { RestLink } from "apollo-link-rest";
import moment from "moment";
import {
  // fetchGigs,
  SearchResponse,
  SearchResponseRequested,
  SearchValue,
  GetFilters,
  SearchSuggestions,
  // fetchStateSuggesionsInit,
  // fetchRegionSuggestionsInit,
  skillListingCount,
  skillListingTotalCount,
  SearchCandidateMarketValue,
  fetchKeySearchDynamicLocation,
  fetchKeySearchCompanyAndIndustries,
} from "../../redux/actions";
import { HttpLink } from "apollo-link-http";
import {
  DownOutlined,
  SearchOutlined,
  UserAddOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import MobilePagination from "../../components/Pagination/MobilePagination";
// CSS
import "./Search_Results.css";
import downArrow from "../../assets/icons/downArrow.png";

// ICONS
import { LoadingOutlined, CloseOutlined } from "@ant-design/icons";
import { debounce, getValueFromURLSearchParams, timeout } from "../../shared/helpers";
import FilterIcon from "../../assets/img/filtericon.svg";
import SortIcon from "../../assets/img/sorticon.svg";
// ANTD
import GigsCard from "../SearchSkillListing/GigsCard";
import { connect } from "react-redux";
// redux Actions
import { fetchUserSkillListing } from "../../redux/actions";
import { useLocation } from "react-router";
import history from "../../routes/history";
import Filters from "../SearchSkillListing/MobileComponents/Filters";
import { MdNearbyError } from "react-icons/md";

import PlaceBidModal from "../../components/PlaceBidModal/PlaceBidModal";
import Search_Bar from "./Search_Bar";
import Loader from "../../components/Loading/Loader";
import ExperienceLevel from "../SearchSkillListing/components/ExperienceLevelFilter/ExperienceLevelFilter";
import FilterLocation from "../SearchSkillListing/components/LocationFilter/location.filter.js";
import FilterCity from "../SearchSkillListing/components/LocationFilter/city.Filter.js";
import FilterRegion from "../SearchSkillListing/components/LocationFilter/region.Filter.js";
import FilterState from "../SearchSkillListing/components/LocationFilter/state.Filter.js";
import BudgetFilter from "../SearchSkillListing/components/BudgetFilter/BudgetFilter";
import emptyresult from "../../assets/img/cuate@2x.png";
import { GetQueryParams } from "../../shared/helpers";
import FilterCompany from "../SearchSkillListing/components/LocationFilter/company.Filter";
import FilterIndustry from "../SearchSkillListing/components/LocationFilter/prev.Filter";
import FilterSkill from "../SearchSkillListing/components/LocationFilter/skill.Filter";
import FilterVisa from "../SearchSkillListing/components/LocationFilter/visa.Filter";

const Search_Results = (props) => {
  const [modal, setModal] = useState(false);
  const dispatch = useDispatch();
  const url = useLocation();
  const LocalSelectedSkillListings = JSON.parse(localStorage.getItem("SelectedSkills"));
  const { authToken } = props;
  // searchSkillListingReducer
  const filters = useSelector(
    (state) => state.searchSkillListingReducer.filters
  );

  // const Count = useSelector(
  //   (state) => state.searchSkillListingReducer.skillListingCount
  // );

  // const countLoading = useSelector(
  //   (state) => state.searchSkillListingReducer.countLoading
  // );

  const totalCount = useSelector(
    (state) => state.searchSkillListingReducer.skillListingTotalCount
  );

  const totalCountError = useSelector(
    (state) => state.searchSkillListingReducer.error
  );

  const totalCountLoading = useSelector(
    (state) => state.searchSkillListingReducer.totalCountLoading
  );

  const token = useSelector((state) => state.authReducer.user);
  const { Text } = Typography;
  const [skillListings, setSkillListings] = useState([]);
  const [gqlError, setGqlError] = useState();
  const [experienceLevelRadioValue, setExperienceLevelRadioValue] =
    useState("");
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  const [filterError, setFilterError] = useState("");

  const [searchFilters, setSearchFilters] = useState({
    location: [],
    cityId: [],
    regionId: [],
    countryId: [],
    city: null,
    region: [],
    state: [],
    skillListing_type: null,
    budgetType: null,
    ExperienceLevel: [],
    budgetMin: null,
    budgetMax: null,
    NearBy: null,
    hidePrevious: null,
    visa: [],
    visaName: [],
    company: null,
    industry: [],
    industryId: [],
    skill: null,
  });
  const [candidateId, setCandidateId] = useState();
  const [visible, setVisible] = useState(false);
  const [closeModalSkill, setCloseModalSkill] = useState(false);
  const [closeModalLoc, setCloseModalLoc] = useState(false);
  const [closeModalCity, setCloseModalCity] = useState(false);
  const [closeModalRegion, setCloseModalRegion] = useState(false);
  const [closeModalState, setCloseModalState] = useState(false);
  const [closeModalBudget, setCloseModalBudget] = useState(false);
  const [closeModalExp, setCloseModalExp] = useState(false);
  const [closeModalCompany, setCloseModalCompany] = useState(false);
  const [closeModalVisa, setCloseModalVisa] = useState(false);
  const [closeModalPrev, setCloseModalPrev] = useState(false);
  const [sortvisible, setSortVisible] = useState(false);
  const [sortType, setSortType] = useState("MOST_RELEVANT");
  // const [pageNo, setPageNo] = useState(1);
  // const [currentPage, setCurrentPage] = useState(1);
  const [emptyCityInput, setEmptyCityInput] = useState();
  const [emptyRegionInput, setEmptyRegionInput] = useState();
  const [emptyCountryInput, setEmptyCountryInput] = useState();
  const [emptyCompanyInput, setEmptyCompanyInput] = useState();
  const [emptyIndustryInput, setEmptyIndustryInput] = useState();
  const [emptySkillInput, setEmptySkillInput] = useState();
  const [checkBox, setCheckedBox] = useState([]);
  const [emptyPrevIndustryInput, setEmptyPrevIndustryInput] = useState();

  const [pageNo, setPageNo] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);

  const [latitude, setLatitude] = useState(
    localStorage.getItem("latitude") ?? null
  );
  const [longitude, setLongitude] = useState(
    localStorage.getItem("longitude") ?? null
  );
  const [showMeasurements, setshowMeasurements] = useState(false);

  const [lat, setLat] = useState(null);
  const [long, setLong] = useState(null);
  const [isformOpen, setIsFormOpen] = useState(false);
  const [userDataList, setUserDataList] = useState([]);
  const [jobTypeRadio, setJobTypeRadios] = useState(
    url?.search
      ?.split("skillListing_type=")[1]
      ?.split("&")[0]
      ?.replaceAll("+", " ")
      ?.replaceAll("%2C", ",") ?? null
  );

  const [placebidModal, setplacebidModal] = useState(false);
  const [candidateList, setcandidateList] = useState([]);
  const [checkRadio, setCheckRadio] = useState(null);
  const [HidePagePvt, setHidePagePvt] = useState(false);


  // const [checkRadioLoc, setCheckRadioLoc] = useState(null);

  //  const[checkLocObject,setCheckLocObject]= useState(null);
  // const [checkLocationCity, setCheckCityId] = useState(null);
  // const [checkLocationRegion, setCheckRegionId] = useState(null);

  const [skillListingIds, setSkillListingIds] = useState(JSON.parse(localStorage.getItem("SelectedSkills"))??[]);
  const [filterCount, setFilterCount] = useState();
  const [checkAllClicked, setcheckAllClicked] = useState();
  // const [hideCheck, setHideCheck] = useState(false);
  const [clearSort, setClearSort] = useState(false);

  const [sortTypeText, setsortTypeText] = useState("Most Relevant");
  const [budget, setBudget] = useState({
    budgetMin: null,
    budgetMax: null,
    budgetType: null,
  });
  const [clearForm, setClearForm] = useState(false);
  const professionCode = useSelector(
    (state) => state.profileReducer?.user?.profile?.ProfessionCode
  );
  const profileTypeRes = useSelector((state) => state.profileReducer.user);
  const [nearBy, setNearby] = useState({
    latitude: 33.5773696,
    longitude: 73.1480064,
    maxDistance: 50,
  });
  const nearbyLocation = JSON.stringify(nearBy);
  // const [perPage, setPerPage] = useState('24'); //windowDimensions.width > 768 ? '24' : '20'
  const [selectText, setSelectText] = useState(true);
  let userProfile = JSON.parse(localStorage.getItem("userProfile"));

  const [perPage, setPerPage] = useState("24");
  const [checkRadioLoc, setCheckRadioLoc] = useState([]);

  const [checkRadioCity, setCheckRadioCity] = useState(null);
  const [checkRadioRegion, setCheckRadioRegion] = useState([]);
  const [checkRadioCountry, setCheckRadioCountry] = useState([]);
  const [checkRadioVisa, setCheckRadioVisa] = useState([]);
  const [checkRadioVisaName, setCheckRadioVisaName] = useState([]);
  const [checkRadioCompany, setCheckRadioCompany] = useState(null);
  const [checkRadioIndustry, setCheckRadioIndustry] = useState([]);
  const [checkRadioSkill, setCheckRadioSkill] = useState(null);
  const [hideCheck, setHideCheck] = useState(null);
  const [checkCityId, setCheckCityId] = useState([]);
  const [checkRegionId, setCheckRegionId] = useState([]);
  const [checkCountryId, setCheckCountryId] = useState([]);
  const [checkIndustryId, setCheckIndustryId] = useState([]);
  const [checkVisaIdArray, setCheckVisaIdArray] = useState([]);



  // const [checkLocationState, setCheckLocationState] = useState(null);
  const [checkCityObject, setCheckCityObject] = useState({
    value: checkRadioCity ?? null,
  });
  //for city
  const [checkLocObject, setCheckLocObject] = useState({
    value: checkRadioLoc ?? null,
    value2: parseInt(checkCityId) ?? null,
  });
  // for region
  const [checkRegionObject, setCheckRegionObject] = useState({
    value: checkRadioRegion ?? [],
    value2: parseInt(checkRegionId) ?? [],
  });
  // for country
  const [checkCountryObject, setCheckCountryObject] = useState({
    value: checkRadioCountry ?? null,
    value2: parseInt(checkCountryId) ?? null,
  });

  const [locationCheck, setLocationCheck] = useState(false);

  const [searcheyword, setSearchKeyword] = useState("");

  const [sort, setSort] = useState("");

  const [searchBarcalled, setSearchBarcalled] = useState(false);
  const [searchLocationFilter, setsearchLocationFilter] = useState({});
  const [checkIndustryObject, setCheckIndustryObject] = useState({
    value: checkRadioIndustry ?? [],
    value2: parseInt(checkIndustryId) ?? [],
  });

  useEffect(() => {
    const obj = {
      _page: 1,
      _perPage: perPage,
      _sort: sortType,
      search:
        props.value === 0
          ? ""
          : props.job_title
          ? props.job_title
          : props.value,
      hide: true,

      NearBy: searchFilters.NearBy ? true : null,
      Latitude: localStorage.getItem("latitude")
        ? localStorage.getItem("latitude").toString()
        : null,
      Longitude: localStorage.getItem("longitude")
        ? localStorage.getItem("longitude").toString()
        : null,

      maxDistance: "50",

      BudgetMax: budget.budgetMax,
      BudgetMin: budget.budgetMin,
      BudgetType: budget.budgetType,
      GigType: jobTypeRadio,
      CityId: checkCityId,
      RegionId: checkRegionId,
      CountryId: checkCountryId,
      // Location: checkRadioLoc,
      Experience: checkBox,
      searchType: "Skills",
    };
    const params = { obj };
    setsearchLocationFilter(params);
  }, [searchFilters]);

  function replaceSpecialChars(str) {
    return decodeURIComponent(str.replace(/\+/g, "%20"));
  }

  useEffect(() => {
    if (url.search != "") {
      const queryparams = GetQueryParams();
      let keyword;
      if (url?.search?.split("query=")[1]) {
        keyword = replaceSpecialChars(
          url?.search?.split("query=")[1]?.split("&")[0].replaceAll("+", " ")
        ).replaceAll('"', "");
        //  dispatch(SearchCandidateMarketValue(keyword)); // action dispatched
        setSearchKeyword(keyword);
      } else {
        keyword =
          props.value === 0
            ? ""
            : props.job_title
            ? props.job_title
            : props.value;
        setSearchKeyword(keyword);
      }

      setSortType(
        // url?.search?.split("sortType=")[1]?? "MOST_RECENT"
        url?.search?.split("&")
        ?.find(param => param.includes("sortType="))
        ?.split("sortType=")[1]
        ?.split("&")[0] ?? "MOST_RECENT"
        );

      setsortTypeText( 
        url?.search?.split("&")?.find(param => param.includes("sortType="))?.split("sortType=")[1]?.split("&")[0] =="MOST_RECENT" ? "New skill listing"
        :url?.search?.split("&")?.find(param => param.includes("sortType="))?.split("sortType=")[1]?.split("&")[0] =="MOST_RELEVANT" ? "Most Relevant"
        :url?.search?.split("&")?.find(param => param.includes("sortType="))?.split("sortType=")[1]?.split("&")[0] =="MOST_NEWEST" ? "Newest"       
        :url?.search?.split("&")?.find(param => param.includes("sortType="))?.split("sortType=")[1]?.split("&")[0] =="RATINGS_HIGH_TO_LOW" ? "Ratings High to Low"
        :url?.search?.split("&")?.find(param => param.includes("sortType="))?.split("sortType=")[1]?.split("&")[0] =="RATINGS_LOW_TO_HIGH" ? "Ratings Low to High"
        : url?.search?.split("&")?.find(param => param.includes("sortType="))?.split("sortType=")[1]?.split("&")[0] =="PAY_HI_TO_LOW" ? "Desired Rate High to Low"
        :url?.search?.split("&")?.find(param => param.includes("sortType="))?.split("sortType=")[1]?.split("&")[0] =="PAY_LOW_TO_HI" ? "Desired Rate Low to High"

        : "Most Relevant");
            
   

      setPageNo(
        url.search?.split("pageNo=")[1]
          ? parseInt(url.search?.split("pageNo=")[1])
          : 1
      );
      setCurrentPage(
        url.search?.split("pageNo=")[1]
          ? parseInt(url.search?.split("pageNo=")[1])
          : 1
      );
      // setPerPage(pageSize);
      // setSkillListingIds([]);
      setcheckAllClicked(false);
      setSelectText(true);

      setBudget({
        budgetMax: url?.search.split("budgetMax=")[1]?.split("&")[0] ?? null,
        budgetMin: url?.search.split("budgetMin=")[1]?.split("&")[0] ?? null,
        budgetType: url?.search.split("budgetType=")[1]?.split("&")[0] ?? null,
      });
      setLocationCheck(url.search?.split("nearby=")[1] ? true : false);
      setHideCheck(url?.search.split("hide=")[1]?.split("&")[0] ?? null);
      setCheckCityId(queryparams.cityId ? JSON.parse(queryparams.cityId) : []);
     
      setCheckedBox(
        queryparams?.experience
          ? JSON.parse(queryparams?.experience?.replaceAll("+", " "))
          : []
      );
      // setJobTypeRadios(
      //   url?.search
      //   ?.split("skillListing_type=")[1]
      //   ?.split("&")[0]
      //   ?.replaceAll("+", " ")
      //   ?.replaceAll("%2C", ",") ?? null,
      // );
      // setCheckRegionId(
      //   url?.search?.split("regionId=")[1]?.split("&")[0] ?? null
      // );

      // setCheckCountryId(
      //   JSON.parse(queryparams.countryId) ?? null
      // );
      setCheckIndustryId(
        queryparams?.industryId ? JSON.parse(queryparams?.industryId) : []
      );
      setCheckRadio(
        url?.search
          .split("experience=")[1]
          ?.split("&")[0]
          ?.replaceAll("+", " ") ?? null
      );
     

      //city
      // setCheckRadioLoc(
      //   url?.search
      //     ?.split("City=")[1]
      //     ?.split("&")[0]
      //     ?.replaceAll("+", " ")
      //     ?.replaceAll("%2C", ",") ?? []
      // );

      // setCheckLocObject(
      //   url?.search
      //     ?.split("City=")[1]
      //     ?.split("&")[0]
      //     ?.replaceAll("+", " ")
      //     ?.replaceAll("%2C", ",") ?? null
      // )

      // //city
      //       setCheckRadioCity(
      //         url?.search
      //           ?.split("City=")[1]
      //           ?.split("&")[0]
      //           ?.replaceAll("+", " ")
      //           ?.replaceAll("%2C", ",") ?? null
      //       );
      //       setCheckCityObject(
      //         url?.search
      //           ?.split("City=")[1]
      //           ?.split("&")[0]
      //           ?.replaceAll("+", " ")
      //           ?.replaceAll("%2C", ",") ?? null
      //       )

      //region
      // setCheckRadioRegion(
      //   url?.search
      //     ?.split("Region=")[1]
      //     ?.split("&")[0]
      //     ?.replaceAll("+", " ")
      //     ?.replaceAll("%2C", ",") ?? []
      // );
      // setCheckRegionObject(
      //   url?.search
      //     ?.split("Region=")[1]
      //     ?.split("&")[0]
      //     ?.replaceAll("+", " ")
      //     ?.replaceAll("%2C", ",") ?? null
      // )
      ///////
         //city
      const cityQueryParam = queryparams?.City?.replaceAll("+", " ")?.replaceAll("%2C", ",")
      setCheckRadioLoc(
        queryparams?.City ? JSON.parse(cityQueryParam) : []
      );

      //region
      const regionQueryParam = queryparams?.Region?.replaceAll("+", " ")?.replaceAll("%2C", ",")
      setCheckRadioRegion(
        queryparams?.Region ? JSON.parse(regionQueryParam) : []
      );

      //state
      const stateQueryParam = queryparams?.Country?.replaceAll("+", " ")?.replaceAll("%2C", ",")
           setCheckRadioCountry(
        queryparams?.Country ? JSON.parse(stateQueryParam) : []
      );
          // setCheckCountryObject(
      //   JSON.parse(queryparams.Country)
      // )
      setCheckRadioVisaName(
        queryparams?.VisaName ? JSON.parse(queryparams?.VisaName) : []
      );

      const industryQueryParam = queryparams?.Industry?.replaceAll(
        "+",
        " "
      )?.replaceAll("%2C", ",");
      setCheckRadioIndustry(queryparams?.Industry ? JSON.parse(industryQueryParam) : []);


      setSearchFilters({
        ...searchFilters,
        location:
          searchFilters?.location?.length > 0
            ? searchFilters.location
            : queryparams.City
            ? JSON.parse(queryparams.City)
            : [],
        //city
        // city:
        // url?.search
        // ?.split("City=")[1]
        // ?.split("&")[0]
        // ?.replaceAll("+", " ")
        // ?.replaceAll("%2C", ",") ?? null,
        //region
        region: queryparams?.Country ? JSON.parse(queryparams?.Country) : [],

        //state
        state: queryparams.Region ? JSON.parse(queryparams.Region) : [],

        cityId: queryparams.cityId ? JSON.parse(queryparams.cityId) : [],
        regionId: queryparams.regionId ? JSON.parse(queryparams.regionId) : [],
        countryId: queryparams.countryId
          ? JSON.parse(queryparams.countryId)
          : [],
          company: queryparams?.Company?.replace(/-\*/g, "&").replaceAll("+", " ") ?? null,
        // company: queryparams?.Company ?? null,
        visa: queryparams?.VisaStatusId
          ? JSON.parse(queryparams.VisaStatusId)
          : [],
        visaName: queryparams?.VisaName ? JSON.parse(queryparams.VisaName) : [],
        industry: queryparams?.Industry ? JSON.parse(queryparams.Industry) : [],
        industryId: queryparams?.industryId
          ? JSON.parse(queryparams.industryId || [])
          : [],

        // industry: queryparams?.Industry?.replace(/-\*/g, "&").replaceAll("+", " ")  ?? null,
        // industry: queryparams?.Industry ?? null,
        skillListing_type:
          url?.search
            ?.split("skillListing_type=")[1]
            ?.split("&")[0]
            ?.replaceAll("+", " ")
            ?.replaceAll("%2C", ",") ?? null,
        budgetType: url.search?.split("budgetType=")[1]?.split("&")[0] ?? null,
        ExperienceLevel: queryparams?.experience
          ? JSON.parse(queryparams?.experience?.replaceAll("+", " "))
          : [],
        budgetMin: url.search?.split("budgetMin=")[1]?.split("&")[0] ?? null,
        budgetMax: url.search?.split("budgetMax=")[1]?.split("&")[0] ?? null,
        NearBy: url.search?.split("nearby=")[1] ? true : null,
        hidePrevious: url.search.split("hide=")[1]?.split("&")[0] ?? null,
      });
      
      // setCheckRadioIndustry(queryparams?.Industry?.replace(/-\*/g, "&").replaceAll("+", " ")  ?? null
      // );
      
      // setCheckRadioCompany(queryparams?.Company ? queryparams?.Company?.replace(/\+/g, ' ') : null);
      setCheckRadioCompany(queryparams?.Company?.replace(/-\*/g, "&").replaceAll("+", " ") ?? null
      );
      const obj = {
        _page: 1,
        _perPage: perPage,
        search: keyword,
        sort:
          url?.search
            ?.split("&")
            ?.find((param) => param.includes("sortType="))
            ?.split("sortType=")[1]
            ?.split("&")[0] ?? "MOST_RECENT",
        NearBy: url.search?.split("nearby=")[1] ? true : null,
        Latitude: localStorage.getItem("latitude")
          ? localStorage.getItem("latitude").toString()
          : null,
        Longitude: localStorage.getItem("longitude")
          ? localStorage.getItem("longitude").toString()
          : null,
        maxDistance: "50",
        hide: url.search.split("hide=")[1]?.split("&")[0] ?? null,
        BudgetMax: url.search?.split("budgetMax=")[1]?.split("&")[0] ?? null,
        BudgetMin: url.search?.split("budgetMin=")[1]?.split("&")[0] ?? null,
        BudgetType: url.search?.split("budgetType=")[1]?.split("&")[0] ?? null,
        GigType:
          url?.search
            ?.split("skillListing_type=")[1]
            ?.split("&")[0]
            ?.replaceAll("+", " ")
            ?.replaceAll("%2C", ",") ?? null,
        CityId: queryparams.cityId ? JSON.parse(queryparams.cityId) : [],
        RegionId: queryparams.regionId ? JSON.parse(queryparams.regionId) : [],
        CountryId: queryparams.countryId
          ? JSON.parse(queryparams.countryId)
          : [],
        Experience:getValueFromURLSearchParams('experience') ?? null,
        searchType: "Skills",
      };
      const params = { obj };
      // dispatch(skillListingCount(params));
      dispatch(skillListingTotalCount(params));
    } else {
      // setSearchKeyword('');
      setSearchFilters({
        ...searchFilters,
        location: [],
        region: [],
        state: [],
        cityId: [],
        regionId: [],
        countryId: [],
        visa: [],
        company: null,
        industry: null,
        skillListing_type: null,
        budgetType: null,
        ExperienceLevel: [],
        budgetMin: null,
        budgetMax: null,
        NearBy: null,
        hidePrevious: null,
      });
      setBudget({
        budgetMax: null,
        budgetMin: null,
        budgetType: null,
      });
      setPageNo(1);
      setCurrentPage(1);
      // setPerPage(pageSize);
      // setSkillListingIds([]);
      setcheckAllClicked(false);
      setSelectText(true);

      setHideCheck(null);
      setCheckRadioLoc([]);
      setCheckLocObject(null);
      setCheckRadioCity(null);
      setCheckRadioRegion([]);
      setCheckRegionObject(null);
      setCheckRadioCountry([]);
      setCheckCountryObject(null);
      setCheckRegionId([]);
      setCheckCountryId([]);
      setCheckIndustryId([]);
      setCheckCityId([]);
      setCheckedBox([]);
      setJobTypeRadios(null);
      setCheckRadio(null);
      setLocationCheck(false);

      handleCityChange();
      handleRegionChange();
      handleCountryChange();

      setSortType("MOST_RELEVANT");
      setsortTypeText("Most Relevant");

      const obj = {
        _page: 1,
        _perPage: perPage,
        search:
          props.value === 0
            ? ""
            : props.job_title
            ? props.job_title
            : props.value,
        _sort: sortType,
        NearBy: null,
        Latitude: localStorage.getItem("latitude")
          ? localStorage.getItem("latitude").toString()
          : null,
        Longitude: localStorage.getItem("longitude")
          ? localStorage.getItem("longitude").toString()
          : null,
        maxDistance: "50",
        hide: null,
        BudgetMax: null,
        BudgetMin: null,
        BudgetType: null,
        GigType: null,
        CityId: [],
        RegionId: [],
        CountryId: [],
        Location: null,
        Experience: [],
        searchType: "Skills",
      };
      const params = { obj };
      // dispatch(skillListingCount(params));
      dispatch(skillListingTotalCount(params));
    }
  }, [url.search, url.pathname, props.value]);

  useEffect(() => {
    if (props.value) {
      addQuery(
        "query",
        props.value === 0 ? "" : props.job_title ? props.job_title : props.value
      );
    }

    if (props.value.length === 0) {
      removeQuery("query");
      setSearchKeyword("");
    }

    // else{
    //   removeQuery('query');
    // }
    // if(props.value ===0 || props.job_title === " " , props.value === " " ){
    //   removeQuery('query');
    // }
    // const obj = {
    //   _page: 1,
    //   _perPage: perPage,
    //   search:
    //     props.value === 0
    //       ? ""
    //       : props.job_title
    //       ? props.job_title
    //       : props.value,
    //   _sort: "MOST_RECENT",
    //   NearBy: searchFilters.NearBy ? true : null,
    //   Latitude: localStorage.getItem("latitude")
    //     ? localStorage.getItem("latitude").toString()
    //     : null,
    //   Longitude: localStorage.getItem("longitude")
    //     ? localStorage.getItem("longitude").toString()
    //     : null,

    //   maxDistance: "50",
    //   hide: hideCheck ? true : null,

    //   BudgetMax: budget.budgetMax,
    //   BudgetMin: budget.budgetMin,
    //   BudgetType: budget.budgetType,
    //   GigType: jobTypeRadio,
    //   CityId: checkCityId,
    //   RegionId: checkRegionId,
    //   Location: checkRadioLoc,
    //   Experience: checkBox,
    // };
    // const params = { obj };
    // dispatch(skillListingCount(params));
  }, [props.value]);

  useEffect(() => {
    if (windowDimensions.width < 769) {
      setPerPage("20");
    } else {
      setPerPage("24");
    }
  }, [windowDimensions.width]);

  // useEffect(()=>{
  //   setSkillListingIds(LocalSelectedSkillListings);
  // },[LocalSelectedSkillListings])

  //// Search Skill Listing Start//////////
  const query = gql`
  query {
    skilllistings(
      _sort: ${sortType}
      _page: ${pageNo},
      _perPage: ${perPage},
      search: "${searcheyword}",
      GigType: "${searchFilters.skillListing_type}",
      CityId: ${JSON.stringify(searchFilters?.cityId)},
      RegionId:${JSON.stringify(searchFilters?.regionId)},
      CountryId:${JSON.stringify(searchFilters?.countryId)},
      VisaStatusId: ${JSON.stringify(searchFilters?.visa ?? null )},
      CompanyName: "${searchFilters.company ? searchFilters.company?.replaceAll("+", " ")?.replaceAll("-*","&")  : null}",
      IndustryName:${JSON.stringify(searchFilters.industryId)},
      BudgetMin : "${searchFilters.budgetMin}",
      BudgetMax : "${searchFilters.budgetMax}",
      BudgetType : "${searchFilters.budgetType}",
      Experience: ${JSON.stringify(searchFilters?.ExperienceLevel)},
      NearBy : "${searchFilters.NearBy}",
      searchType : Skills,      
      Authorization : "${token ? token.authToken : null}",
      Latitude : "${latitude}",
      Longitude : "${longitude}",
      maxDistance : "50", 
      hide: ${searchFilters.hidePrevious},
    ) {
     
      data {
        SkillListingId
          Title
          Description
          CreatedBy
          ModifiedBy
          bidstatus
          prevviewed
          TotalCount{
            count{total}
          }
          BudgetTypes{

            BudgetTypeName
  
        }
          MinimumBid
          ClientRate
          JobOrderTypes{JobOrderTypeName}
          explevel{
                ExperienceLevelName
            }
          users {UserName,EmailAddress,MobilePhone,LastSuccessfulLoginDate, LastLoginDate,Profiles{ 
            FirstName,
            LastName,
            Rating,
            Review, PictureUrl, LastLoginDate,
         ExperienceLevels{
          ExperienceLevelName
      }}}
        }
    }
  }
`;

  const BackendApiBaseUrl = process.env.REACT_APP_API_URL;

  const [hitQuery, { loading, error, data, refetch, called }] =
    useLazyQuery(query);

  const httpLink = new HttpLink({
    uri: `${BackendApiBaseUrl}/guest/skilllisting/search`,
  });

  const client = new ApolloClient({
    cache: new InMemoryCache(),
    link: ApolloLink.from([httpLink]),
  });

  useEffect(() => {
    props.searchResponse(data);
  }, [data, props.value, loading]);

  useEffect(() => {
    // setPageNo(1);
    debounce(hitQuery());
    // dispatch(SearchSuggestions(props.value));
  }, [searchFilters,pageNo]);

  //Get filters
  useEffect(() => {
    debounce(hitQuery());
    dispatch(GetFilters({ fromSearch: true }));
    // dispatch(fetchStateSuggesionsInit())
    // dispatch(fetchRegionSuggestionsInit())
  }, []);

  useEffect(() => {
    if (Object.keys(searchLocationFilter)?.length) {
      const params = {
        body: searchLocationFilter,
      };
      dispatch(fetchKeySearchDynamicLocation(params));
    }
  }, [searchLocationFilter]);

  useEffect(() => {
    if (Object.keys(searchLocationFilter).length) {
      const params = {
        body: searchLocationFilter,
      };
      dispatch(fetchKeySearchCompanyAndIndustries(params));
    }
  }, [searchLocationFilter]);

  useEffect(() => {
    // saving loading state to reducer from graphQL

    if (props.value.length > 0) {
      props.SearchResponseRequested(loading);
    }
  }, [loading]);

  useEffect(() => {
    setSkillListings(data);
    setGqlError(error);
  }, [data, error]);

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }
  const { Option } = Select;

  const closeIconHandler = (type) => {
    removeQuery("pageNo");
    const obj = {
      _page: 1,
      _perPage: perPage,
      _sort: sortType,
      search:
        props.value === 0
          ? ""
          : props.job_title
          ? props.job_title
          : props.value,
      BudgetMax: type === "budget" ? null : budget.budgetMax,
      BudgetMin: type === "budget" ? null : budget.budgetMin,
      BudgetType: type === "budget" ? null : budget.budgetType,
      GigType: type == "jobType" ? null : searchFilters.skillListing_type,
      CityId: type == "city" ? [] : searchFilters?.cityId,
      RegionId: type == "region" ? [] : searchFilters.regionId,
      CountryId: type == "country" ? [] : searchFilters.countryId,
      // Location: type == "location" ? null : searchFilters.location,
      Experience: type == "experience" ? [] : searchFilters.ExperienceLevel,
      searchType: "Skills",
    };
    const params = { obj };
    // dispatch(skillListingCount(params));
    dispatch(skillListingTotalCount(params));
    if (
      searchFilters.ExperienceLevel.length === 0 &&
      type == "experience"
      // searchFilters.ExperienceLevel && type === "experience"
    ) {
      setSearchFilters({ ...searchFilters, ExperienceLevel: [] });
      setCheckRadio(null);
      setCheckedBox([]);
      setFilter({ ExperienceLevel: [] });
    }
    if (
      (searchFilters.location || searchFilters.location?.length < 1) &&
      type == "city"
      // searchFilters.location && type === "location"
    ) {
      setSearchFilters({
        ...searchFilters,
        location: [],
        cityId: null,
        // regionId: null,
      });
      setCheckRadioLoc([]);
      setCheckLocObject(null);
      setCheckCityId([]);
      setCheckedBox([]);
      setFilter({ location: [], cityId: [] });
      // setFilter({ location: null, cityId: null, regionId: null,});
    }

    //city
    // if (
    //   (searchFilters.city || searchFilters.city === null) &&
    //   type == "city"
    // ) {
    //   setSearchFilters({
    //     ...searchFilters,
    //     city: null,
    //   });
    //   setCheckRadioCity(null);
    //   setCheckCityObject(null);
    //   setFilter({ city: null});
    // }

    //region
    if (
      (searchFilters.region || searchFilters.region === null) &&
      type == "region"
    ) {
      setSearchFilters({
        ...searchFilters,
        region: null,
        regionId: [],
      });
      setCheckRadioRegion([]);
      setCheckRegionObject(null);
      setCheckRegionId([]);
      setFilter({ region: null, regionId: null });
      setFilter({ region: null });
    }

    //state
    if (
      (searchFilters.state || searchFilters.state === null) &&
      type == "country"
    ) {
      setSearchFilters({
        ...searchFilters,
        state: null,
        countryId: null,
      });
      setCheckRadioCountry([]);
      setCheckCountryObject(null);
      setCheckCountryId([]);
      setFilter({ state: null, countryId: null });
      setFilter({ state: null });
    }

    if (
      (searchFilters.skillListing_type ||
        searchFilters.skillListing_type === null) &&
      type == "jobType"
      // searchFilters.skillListing_type || searchFilters.skillListing_type === null) && type === "jobType"
    ) {
      setSearchFilters({ ...searchFilters, skillListing_type: null });
      setJobTypeRadios(null);
      setFilter({ skillListing_type: null });
    }
    if (
      (searchFilters.budgetMax ||
        (searchFilters.budgetMax === null && searchFilters.budgetMin) ||
        searchFilters.budgetMin === null) &&
      type === "budget"

      // searchFilters.budgetMax && searchFilters.budgetMin && type === "budget"
    ) {
      setSearchFilters({
        ...searchFilters,
        budgetMax: null,
        budgetMin: null,
        budgetType: null,
      });
      setBudget({ budgetMax: null, budgetMin: null, budgetType: null });
      setFilter({ budgetMax: null, budgetMin: null, budgetType: null });
      setFilterError("");
      setClearForm(true);
    }
  };

  const clearAllFunction = () => {
    if (
      searchFilters.ExperienceLevel.length ||
      searchFilters.location ||
      // searchFilters.city ||
      searchFilters.region ||
      searchFilters.state ||
      searchFilters.skillListing_type ||
      (searchFilters.budgetMax &&
        searchFilters.budgetMin &&
        searchFilters.budgetType)
    ) {
      const obj = {
        _page: 1,
        _perPage: perPage,
        _sort: sortType,
        search:
          props.value === 0
            ? ""
            : props.job_title
            ? props.job_title
            : props.value,
        BudgetMax: null,
        BudgetMin: null,
        BudgetType: null,
        GigType: null,
        CityId: null,
        RegionId: null,
        CountryId: null,
        // Location: null,
        Experience: [],
        hide: null,
        searchType: "Skills",
      };
      const params = { obj };
      const params1 = {
        body: searchLocationFilter,
      };
      dispatch(fetchKeySearchDynamicLocation(params1))
      // dispatch(skillListingCount(params));
      dispatch(skillListingTotalCount(params));
    }

    setFilterError("");
    setIsFormOpen(false);
    // setVisible(false);
    setJobTypeRadios(null);
    setCheckRadio(null);
    setCheckRadioLoc([]);
    //for visa statuses
    setCheckVisaIdArray([]);
    setCheckRadioVisa([]);

    //for prev industry
    setCheckRadioIndustry(null);
    setEmptyPrevIndustryInput("");

    //for company
    setCheckRadioCompany(null);
    setEmptyCompanyInput("")

    setCheckLocObject("");
    setCheckRadioCity("");
    setCheckCityObject("");
    setCheckRadioRegion([]);
    setCheckRegionObject("");
    setCheckRadioCountry([]);
    setCheckCountryObject("");
    setCheckCityId([]);
    setCheckedBox([]);
    setCheckRegionId([]);
    setCheckCountryId([]);
    setCheckIndustryId([])
    setClearForm(true);
    setHideCheck(false);
    setBudget({ budgetMax: null, budgetMin: null, budgetType: null });
    setSearchFilters({
      ...searchFilters,
      location: [],
      city: null,
      region: null,
      state: null,
      cityId: null,
      regionId: null,
      countryId: null,
      skillListing_type: null,
      budgetType: null,
      ExperienceLevel: [],
      budgetMin: null,
      budgetMax: null,
      hidePrevious: null,
    });
    setFilterCount(0);
    // removeQuery("location");
    removeQuery("City");
    removeQuery("Region");
    removeQuery("Country");
    removeQuery("skillListing_type");
    removeQuery("experience");
    removeQuery("budgetMax");
    removeQuery("budgetMin");
    removeQuery("budgetType");
    removeQuery("Company");
    removeQuery("VisaStatusId")
    removeQuery("Industry")
    removeQuery("cityId");
    removeQuery("regionId");
    removeQuery("countryId");
    removeQuery("Company");
    removeQuery("Industry");
    removeQuery("VisaStatusId");
    removeQuery("VisaName");
    setEmptyCityInput("");
    setEmptyCountryInput("");
    setEmptyRegionInput("");
  };

  const getFilterCount = () => {
    let count = 0;
    if (searchFilters.ExperienceLevel.length) {
      count++;
    }
    if (searchFilters.NearBy != null) {
      count++;
    }
    if (searchFilters.budgetMax != null) {
      count++;
    }
    if (searchFilters.budgetMin != null) {
      count++;
    }
    if (searchFilters.budgetType != null) {
      count++;
    }

    if (searchFilters?.location?.length < 1) {
      count++;
    }
    // if (searchFilters?.city != null) {
    //   count++;
    // }
    if (searchFilters?.region != null) {
      count++;
    }
    if (searchFilters?.state != null) {
      count++;
    }
    if (searchFilters?.skillListing_type != null) {
      count++;
    }
    if (searchFilters?.hidePrevious != null) {
      count++;
    }
    setFilterCount(count);
  };

  useEffect(()=>{
    if(skillListingIds?.length<1){
        setcheckAllClicked(false);
        setSelectText(true);
    }
  },[skillListingIds])

  const ClearAll = (props) => {
    return (
      <div className="clearAll-div">
        <div
          className="cancelfilter-btn"
          onClick={() => {
            clearFilter(props.type);
          }}
        >
          Clear all
        </div>
        <button
          className="applyfilter-btn"
          onClick={() => {
            // budget.budgetType == null || budget.budgetMin == null
            //   ?
            //   setFilterError('selectBudget')
            //     :
            applyFilters(props.type);
            filtersCounthandler();
          }}
        >
          Apply
        </button>
      </div>
    );
  };

  // (
  //   Count?.result?.gigCount?.findIndex(e => e.title === 'Contract') != -1  ?
  //   <div style={{ color: "#7e7e7e" }}>
  //   ({(Count?.result?.gigCount[Count?.result?.gigCount?.findIndex(e => e.title === 'Contract')]).count })
  //  </div>
  //    :

  //      <div style={{ color: "#7e7e7e" }}>(0)</div>)

  const cancelBid = () => {
    setSkillListingIds([]);
    setcheckAllClicked(false);
    localStorage.removeItem("SelectedSkills");
    setSelectText(true);
  };

  const clearFilter = (type) => {
    setIsFormOpen(false);
    setVisible(false);
    setCloseModalExp(false);
    setCloseModalSkill(false);
    setCloseModalLoc(false);
    setCloseModalCity(false);
    setCloseModalRegion(false);
    setCloseModalState(false);
    setCloseModalBudget(false);
    setCloseModalCompany(false);
    setCloseModalVisa(false);
    setCloseModalPrev(false);
    if (
      (searchFilters.ExperienceLevel && type == "experience") ||
      (searchFilters.location?.length > 0 && type == "city") ||
      // (searchFilters.city && type == "city") ||
      (searchFilters.region && type == "region") ||
      (searchFilters.state && type == "country") ||
      (type == "industry") ||
      (type == "company") ||
      (searchFilters.skillListing_type && type == "jobType") ||
      (searchFilters.budgetMax &&
        searchFilters.budgetMin &&
        searchFilters.budgetType &&
        type == "budget")
    ) {
      const obj = {
        _page: 1,
        _perPage: perPage,
        _sort: sortType,
        search:
          props.value === 0
            ? ""
            : props.job_title
            ? props.job_title
            : props.value,
        BudgetMax: type === "budget" ? null : budget?.budgetMax,
        BudgetMin: type === "budget" ? null : budget?.budgetMin,
        BudgetType: type === "budget" ? null : budget?.budgetType,
        GigType: type == "jobType" ? null : searchFilters?.skillListing_type,

        CityId: type == "city" ? null : searchFilters?.cityId,
        RegionId: type == "region" ? null : searchFilters?.regionId,
        CountryId: type == "country" ? null : searchFilters?.countryId,
        Experience:
          type == "experience" ? null : searchFilters?.ExperienceLevel,
        searchType: "Skills",
      };
      const params = { obj };
      const params1 = {
        body: searchLocationFilter,
      };
      // dispatch(skillListingCount(params));
      dispatch(fetchKeySearchDynamicLocation(params1));
      dispatch(skillListingTotalCount(params));
      dispatch(fetchKeySearchCompanyAndIndustries(params1));
    }

    if (searchFilters?.ExperienceLevel.length && type == "experience") {
      setSearchFilters({ ...searchFilters, ExperienceLevel: [] });
      setCheckedBox([]);
      setCheckRadio(null);
      setFilter({ ExperienceLevel: [] });
      removeQuery("experience");
    }

    if (checkBox.length == 0 && type == "experience") {
      setCheckRadio(null);
      setCheckedBox([]);
    }

    if (searchFilters.location?.length > 0 && type == "city") {
      setSearchFilters({
        ...searchFilters,
        location: [],
        cityId: null,
      });
      setCheckRadioLoc([]);
      setCheckLocObject(null);
      removeQuery("City");
      setCheckCityId([]);
      setFilter({ location: [], cityId: null });
      removeQuery("cityId");
      // removeQuery("region");
      setEmptyCityInput("");
    }

      //city
      // if (
      //   searchFilters.city  && type == "city"
      // ) {
      //   setSearchFilters({
      //     ...searchFilters,
      //     city: null,
      //   });
      //   setCheckRadioCity(null);
      //   setCheckCityObject(null);
      //   removeQuery("City");
      //   setCheckCityId(null); 
      //   setFilter({ cityId: null });
      //   removeQuery("City"); 
      // }
      //region
      if (
        searchFilters.region  && type == "region"
      ) {
        setSearchFilters({
          ...searchFilters,
          region: null,
          regionId: null,
        });
        setCheckRadioRegion([]);
        setCheckRegionObject(null);
        removeQuery("Region");
        setCheckRegionId([]); 
        setFilter({ region: null });
        removeQuery("regionId"); 
        setEmptyRegionInput('')
      }
      //state
      if (
        searchFilters.state  && type == "country"
      ) {
        setSearchFilters({
          ...searchFilters,
          state: null,
          countryId:null
        });
        setCheckRadioCountry([]);
        setCheckCountryObject(null);
        removeQuery("Country");
        setCheckCountryId([]); 
        setFilter({ state: null });
        removeQuery("countryId"); 
        setEmptyCountryInput('')
      }

      if (searchFilters.industry && type == "industry") {
        setSearchFilters({
          ...searchFilters,
          industry: [],
          industryId:[],

        });
        setCheckIndustryObject(null)
      setCheckRadioIndustry([]);
      setCheckIndustryId([]);
      setFilter({ industryId: [], industry: [] });
      removeQuery("Industry");
      removeQuery("industryId");
      setEmptyIndustryInput("");
      setEmptyPrevIndustryInput("");
      }
      
      if (
        (checkRadioLoc && type == "city") || (emptyCityInput == undefined && type == "city")
        ) {
          setCheckRadioLoc([]); 
          setCheckLocObject(null);
          setCheckCityId([]);
          // setEmptyCityInput('')
        }

    // region
    if (
      (checkRadioRegion && type == "region") ||
      (emptyRegionInput == undefined && type == "region")
    ) {
      setCheckRadioRegion([]);
      setCheckRegionObject(null);
      setCheckRegionId(null);
      // setEmptyRegionInput('')
    }

        // state
        if (
          (checkRadioCountry && type == "country") || (emptyCountryInput == undefined && type == "country")
        ) {
          setCheckRadioCountry([]); 
          setCheckCountryObject(null);
          setCheckCountryId([]); 
          // setEmptyCountryInput('')
        }

         // Previous Industry
        if (
          type == "industry" ||
          (emptyPrevIndustryInput == undefined && type == "industry")
        ) {
          // setPrevIndustryObj(null);
          // removeQuery("Industry");
          // removeQuery("countryId");
          // setEmptyCountryInput("");
          setEmptyIndustryInput("");
          setEmptyPrevIndustryInput("");
        }

    if (searchFilters.skillListing_type && type == "jobType") {
      setSearchFilters({ ...searchFilters, skillListing_type: null });
      setJobTypeRadios(null);
      setFilter({ skillListing_type: null });
      removeQuery("skillListing_type");
    }

    if (jobTypeRadio && type == "jobType") {
      setJobTypeRadios(null);
    }

    if (searchFilters.visa && type == "visa") {
      setSearchFilters({ ...searchFilters, visa: [] });
      setSearchFilters({ ...searchFilters, visaName: [] });
      setCheckRadioVisa([]);
      setFilter({ visa: [] });
      removeQuery("VisaStatusId");
      removeQuery("VisaName");
    }

    if (checkRadioVisa && type == "visa") {
      setCheckRadioVisa([]);
      setCheckRadioVisaName([]);
    }

    if (searchFilters.company && type == "company") {
      setSearchFilters({ ...searchFilters, company: null });
      setCheckRadioCompany(null);
      setFilter({ company: null });
      removeQuery("Company");
      setEmptyCompanyInput("");
    }

    if (checkRadioCompany && type == "company") {
      setCheckRadioCompany(null);
    }

    if (
      type == "company" ||
      (emptyCompanyInput == undefined && type == "company")
    ) {
      setEmptyCompanyInput("");
    }

    if (searchFilters.industry && type == "industry") {
      setSearchFilters({
        ...searchFilters,
        industry: [],
        industryId: [],
      });
      setCheckIndustryObject(null)
      setCheckRadioIndustry([]);
      setCheckIndustryId([]);
      setFilter({ industryId: [], industry: [] });
      removeQuery("Industry");
      removeQuery("industryId");
      setEmptyIndustryInput("");
      setEmptyPrevIndustryInput("");
    }

    if (checkRadioIndustry && type == "industry") {
      setCheckRadioIndustry([]);
      setCheckIndustryId([]);
    }

    if (
      (searchFilters.budgetMax ||
        searchFilters.budgetMin ||
        searchFilters.budgetType) &&
      type === "budget"
    ) {
      setSearchFilters({
        ...searchFilters,
        budgetMax: null,
        budgetMin: null,
        budgetType: null,
      });
      setBudget({ budgetMax: null, budgetMin: null, budgetType: null });
      setFilter({ budgetMax: null, budgetMin: null, budgetType: null });
      setFilterError("");
      setClearForm(true);
      removeQuery("budgetMax");
      removeQuery("budgetMin");
      removeQuery("budgetType");
    }

    if (
      (budget.budgetMax || budget.budgetMin || budget.budgetType) &&
      type == "budget"
    ) {
      setBudget({ budgetMax: null, budgetMin: null, budgetType: null });
      setFilter({ budgetMax: null, budgetMin: null, budgetType: null });
      setClearForm(true);
    }

  };


  


  const handlePrevIndustryChange = (flag) => {
    if (flag) {
      if (emptyCountryInput === "") {
        setEmptyPrevIndustryInput("");
      }
    }
    {
      /* if (!flag) {
      setEmptyCountryInput("");
    } */
    }
    setVisible(flag);
  };
  
  const setFilter = (value) => {
    // setsortTypeText("New skill listing");
    setSearchFilters(Object.assign(searchFilters, value));
    getFilterCount();
  };

  const addQuery = (key, value) => {
    let searchParams = new URLSearchParams(window.location.search);
    if(typeof value == 'string'){
      let newSearch = value.replace(/&/g, "-*");
      searchParams.set(key, newSearch );
    }
    else {
      searchParams.set(key, value );
    }
    history.push({
      search: searchParams.toString(),
    });
  };

  const removeQuery = (key) => {
    let searchParams = new URLSearchParams(window.location.search);
    searchParams.delete(key);
    history.replace({
      search: searchParams.toString(),
    });
  };


  const resetFields = (Reset) => {
    Reset();
  };

  const [locationValue, setLocationValue] = useState([]);

  useEffect(() => {
    var options = [];
    if (filters && filters.location) {
      for (var i = 0; i < filters.location.length; i++) {
        options = [
          ...options,
          {
            value: filters.location[i].LocationWithCountry,
          },
        ];
      }
      setLocationValue(options);
    }
  }, [props.value]);

  const JobMenu = (
    <Menu
      className={`skill-type-menu ${
        filterError === "jobtype" && "filterError"
      }`}
    >
      <div style={{ width: "100%", marginBottom: "20px" }}>
        <Radio.Group value={jobTypeRadio}
          style={{width: "inherit"}}
          className="space radio-color ">          
          <Space style={{width: "inherit" , rowGap: "16px"}} direction="vertical">
            <Radio
              value={"Contract"}
              onClick={(e) => {
                setFilterError("");
                setJobType(e);
              }}
              style={{width: "inherit"}}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "inherit"
                }}
              >
                <div>Contract</div>
                {/* <div style={{ color: "#7e7e7e" }}>
                  {
                    countLoading ? (
                      <LoadingOutlined className="loading" />
                    ) : Count?.result?.gigCount?.findIndex(
                        (e) => e.title === "Contract"
                      ) != -1 ? (
                      <div className="countDiv">
                        (
                        {
                          Count?.result?.gigCount[
                            Count?.result?.gigCount?.findIndex(
                              (e) => e.title === "Contract"
                            )
                          ]?.count
                        }
                        )
                      </div>
                    ) : (
                      <div className="countDiv">(0)</div>
                    )
                    
                  }
                </div> */}
              </div>
            </Radio>
            <Radio
              value={"Permanent"}
              onClick={(e) => {
                setFilterError("");
                setJobType(e);
              }}
              style={{width: "inherit"}} 
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "inherit"
                }}
              >
                <div>Permanent</div>
                {/* {countLoading ? (
                  <LoadingOutlined className="loading" />
                ) : Count?.result?.gigCount?.findIndex(
                    (e) => e.title === "Permanent"
                  ) != -1 ? (
                  <div className="countDiv">
                    (
                    {
                      Count?.result?.gigCount[
                        Count?.result?.gigCount?.findIndex(
                          (e) => e.title === "Permanent"
                        )
                      ]?.count
                    }
                    )
                  </div>
                ) : (
                  <div className="countDiv">(0)</div>
                )} */}
              </div>
            </Radio>

            {userProfile?.Professions?.ProfessionCode === "IT" ? null : (
              <Radio
                value={jobTypeRadio == "Per+Diem" ? jobTypeRadio : "Per Diem"}
                onClick={(e) => {
                  setFilterError("");
                  setJobType(e);
                }}                
              style={{width: "inherit"}} 
              >
                <div
                  style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "inherit",                  
                  whiteSpace: "nowrap",
                  }}
                >
                  <div>Per diem</div>
                  {/* {
                    countLoading ? (
                      <LoadingOutlined className="loading" />
                    ) : Count?.result?.gigCount?.findIndex(
                        (e) => e.title === "Per Diem"
                      ) != -1 ? (
                      <div className="countDiv">
                        (
                        {
                          Count?.result?.gigCount[
                            Count?.result?.gigCount?.findIndex(
                              (e) => e.title === "Per Diem"
                            )
                          ]?.count
                        }
                        )
                      </div>
                    ) : (
                      <div className="countDiv">(0)</div>
                    ) 
                  } */}
                </div>
              </Radio>
            )}
          </Space>
        </Radio.Group>
      </div>
      {filterError === "jobtype" && (
        <div className="filter-error-style">
          Please select any of the gig type
        </div>
      )}

      <div style={{ padding: "0px 5px 0px 4px" }}>
        <ClearAll type="jobType" />
      </div>
    </Menu>
  );

  const setJobType = (e) => {
    setJobTypeRadios(e.target.value);
  };

  const experienceLevel = (
    <Menu
      className={`experiecne-level-menu ${
        filterError === "experience" && "filterError"
      }`}
    >
      {/* <Menu className='experiecne-level-menu filter-menu'> */}
      <ExperienceLevel
        totalCountError={Object.keys(totalCountError).length}
        gqlError={gqlError}
        fromCandMkt={true}
        setFilter={setFilter}
        setcheck={setCheckRadio}
        checkBox={checkBox}
        setCheckedBox={setCheckedBox}
        check={checkRadio}
      />
      {filterError === "experience" && (
        <div className="filter-error-style">Please select experience level</div>
      )}

      <ClearAll type="experience" />
    </Menu>
  );

  const BudgetMenu = (
    <Menu className={`filter-menu-budget`}>
      <div
        className={`budget-filter-container ${
          filterError === "budget" && "filterError"
        }`}
      >
        {/* <BudgetFilter 
          setFilter={setFilter} 
          Filter={searchFilters} 
          budget={budget}
           setBudget={setBudget} 
           clear={clearForm}
            setClear={setClearForm} />
          <ClearAll type="budget" /> */}
        <BudgetFilter
          setFilterError={setFilterError}
          setFilter={setFilter}
          Filter={searchFilters}
          budget={budget}
          setBudget={setBudget}
          clear={clearForm}
          setClear={setClearForm}
        />
        {filterError === "budget" ? (
          <div className="filter-error-style">
            Please enter budget and budget type
          </div>
        ) : (
          filterError === "selectBudget" && (
            <div className="filter-error-style">
              Please select both filters{" "}
            </div>
          )
        )}
        <ClearAll type={"budget"} />
      </div>
    </Menu>
  );

  const locationMenu = (
    // <Menu className="location-filter-menu">
    <Menu
      className={`location-filter-menu ${
        filterError === "city" && "filterError"
      }`}
    >
      <div className="location-filter-menu-inner">
        <FilterLocation
          setlocObj={setCheckLocObject}
          locObj={checkLocObject}
          setFilter={setFilter}
          setcheck={setCheckRadioLoc} //
          check={checkRadioLoc}
          fromCandMkt={true}
          setCheckCityId={setCheckCityId}
          checkCityId={checkCityId}
          emptyCityInput={emptyCityInput}
          setEmptyCityInput={setEmptyCityInput}
          searchLocationFilter={searchLocationFilter}
          // setCheckRegionId={setCheckRegionId}
          // checkRegionId={checkRegionId}
        />
        {filterError === "city" && (
          <div className="filter-error-style">Please select city</div>
        )}

        <ClearAll type="city" />
      </div>
    </Menu>
  );

  // const CityMenu = (
  //   <Menu
  //     className={`location-filter-menu ${
  //       filterError === "city" && "filterError"
  //     }`}
  //   >
  //     <div className="location-filter-menu-inner">
  //       <FilterCity
  //       setcityObj={setCheckCityObject}
  //       cityObj={checkCityObject}
  //         setcheck={setCheckRadioCity}
  //         check={checkRadioCity}
  //         setFilter={setFilter}
  //         setCheckCityId={setCheckCityId}
  //         checkCityId={checkCityId}
  //         addQuery={addQuery}
  //       />
  //       {filterError === "city" && (
  //         <div className="filter-error-style">Please select city</div>
  //       )}

  //       <ClearAll type="city" />
  //     </div>
  //   </Menu>
  // );
  //region
  const RegionMenu = (
    // <Menu className="location-filter-menu">
    <Menu
      className={`location-filter-menu ${
        filterError === "region" && "filterError"
      }`}
    >
      <div className="location-filter-menu-inner">
        <FilterRegion
          setregionObj={setCheckRegionObject}
          regionObj={checkRegionObject}
          setcheck={setCheckRadioRegion}
          check={checkRadioRegion}
          fromCandMkt={true}
          setFilter={setFilter}
          setCheckRegionId={setCheckRegionId}
          checkRegionId={checkRegionId}
          addQuery={addQuery}
          emptyRegionInput={emptyRegionInput}
          setEmptyRegionInput={setEmptyRegionInput}
          searchLocationFilter={searchLocationFilter}
        />
        {filterError === "region" && (
          <div className="filter-error-style">Please select state</div>
        )}

        <ClearAll type="region" />
      </div>
    </Menu>
  );
  //state
  const StateMenu = (
    // <Menu className="location-filter-menu">
    <Menu
      className={`location-filter-menu ${
        filterError === "country" && "filterError"
      }`}
    >
      <div className="location-filter-menu-inner">
        <FilterState
          setcountryObj={setCheckCountryObject}
          countryObj={checkCountryObject}
          setcheck={setCheckRadioCountry}
          check={checkRadioCountry}
          setFilter={setFilter}
          fromCandMkt={true}
          setCheckCountryId={setCheckCountryId}
          checkCountryId={checkCountryId}
          addQuery={addQuery}
          emptyCountryInput={emptyCountryInput}
          setEmptyCountryInput={setEmptyCountryInput}
          searchLocationFilter={searchLocationFilter}
        />
        {filterError === "country" && (
          <div className="filter-error-style">Please select country</div>
        )}

        <ClearAll type="country" />
      </div>
    </Menu>
  );
  //Company
  const CompanyMenu = (
    // <Menu className="location-filter-menu">
    <Menu
      className={`location-filter-menu ${
        filterError === "company" && "filterError"
      }`}
    >
      <div className="location-filter-menu-inner">
        <FilterCompany
          setcheck={setCheckRadioCompany}
          check={checkRadioCompany?.replaceAll("-*","&")}
          setFilter={setFilter}
          fromCandMkt={true}
          addQuery={addQuery}
          emptyCompanyInput={emptyCompanyInput}
          setEmptyCompanyInput={setEmptyCompanyInput}
          searchLocationFilter={searchLocationFilter}
        />
        {filterError === "company" && checkRadioCompany <= 0 && (
          <div className="filter-error-style">Please select Company</div>
        )}

        <ClearAll type={"company"} />
      </div>
    </Menu>
  );

  //Visa
  const VisaMenu = (
    <Menu
      className={`experiecne-level-menu-visa-statuses ${
        filterError === "visa" && "filterError"
      }`}
    >
      <FilterVisa
        setFilter={setFilter}
        checkBox={checkRadioVisaName}
        fromCandMkt={true}
        setCheckedBox={setCheckRadioVisaName}
        setRadioCheck={setCheckRadioVisa}
        checkRadio={checkRadioVisa}
      />
      {!checkRadioVisa.length && filterError === "visa" && (
        <div className="filter-error-style">Please select any visa type</div>
      )}
      <ClearAll type={"visa"} />
    </Menu>
    // // <Menu className="location-filter-menu">
    // <Menu
    //   className={`location-filter-menu ${filterError === "region" && "filterError"
    //     }`}
    // >
    //   <div className="location-filter-menu-inner">
    //     <FilterVisa
    //       setcheck={setCheckRadioVisa}
    //       check={checkRadioVisa}
    //       setFilter={setFilter}
    //       addQuery={addQuery}
    //       searchLocationFilter={searchLocationFilter}
    //      />
    //     {filterError === "visa" && checkRadioVisa?.length <= 0 && (
    //       <div className="filter-error-style">Please select region</div>
    //     )}

    //     <ClearAll type="visa" />
    //   </div>
    // </Menu>
  );

  //Prev
  const PrevMenu = (
    // <Menu className="location-filter-menu">
    <Menu
      className={`location-filter-menu ${
        filterError === "industry" && "filterError"
      }`}
    >
      <div className="location-filter-menu-inner">
        <FilterIndustry
          setIndustryObj={setCheckIndustryObject}
          industryObj={checkIndustryObject}
          setcheck={setCheckRadioIndustry}
          check={checkRadioIndustry}
          setFilter={setFilter}
          addQuery={addQuery}
          fromCandMkt={true}
          emptyIndustryInput={emptyIndustryInput}
          setEmptyIndustryInput={setEmptyIndustryInput}
          searchLocationFilter={searchLocationFilter}
          checkIndustryId={checkIndustryId}
          setCheckIndustryId={setCheckIndustryId}
        />
        {filterError === "industry" && checkRadioIndustry <= 0 && (
          <div className="filter-error-style">Please select an Industry</div>
        )}

        <ClearAll type="industry" />
      </div>
    </Menu>
  );

  const CountDetail = (props) => {
    return (
      <p>
        Showing
        {skillListings?.skilllistings?.data?.[0].TotalCount?.count?.total || 0}{" "}
        results for
        <strong style={{ textTransform: "capitalize" }}>
          {" "}
          "{props.value}"
        </strong>
      </p>
    );
  };

  const { Search } = Input;

  useEffect(() => {
    if (window.location.search) {
      const results = GetQueryParams();
    }
  }, [window.location.search]);

  const onEnterKey = (e) => {
    setPageNo(1);
    if (e.key === "Enter" && e.target.value.length > 0) {
      if (url.pathname != "/query") {
        history.push(`/query/${e.target.value}`);
      }
      props.searchValue(e.target.value);
    }
    dispatch(SearchSuggestions(e.target.value));
  };

  const onClick = ({ key }) => {
    setPageNo(1);
    removeQuery("pageNo");
    setCurrentPage(1); 
    if (key == "most_relevant") {
      setSortType("MOST_RELEVANT");
      setsortTypeText("Most Relevant");
    } else 
    if (key == "most_recent") {
      setSortType("MOST_RECENT");
      addQuery("sortType", "MOST_RECENT");
      setsortTypeText("New skill listing");
    } else if (key == "most_newest") {
      setSortType("MOST_NEWEST");
      addQuery("sortType", "MOST_NEWEST");
      setsortTypeText("Last active");
    } else if (key == "ratings_high_to_low") {
      setSortType("RATINGS_HIGH_TO_LOW");
      addQuery("sortType", "RATINGS_HIGH_TO_LOW");
      setsortTypeText("Ratings high to low");
    } else if (key == "ratings_low_to_high") {
      setSortType("RATINGS_LOW_TO_HIGH");
      addQuery("sortType", "RATINGS_LOW_TO_HIGH");
      setsortTypeText("Ratings low to high");
    } else if (key == "PAY_HI_TO_LOW") {
      setSortType("PAY_HI_TO_LOW");
      addQuery("sortType", "PAY_HI_TO_LOW");
      setsortTypeText("Desired rate high to low");
    } else if (key == "PAY_LOW_TO_HI") {
      setSortType("PAY_LOW_TO_HI");
      addQuery("sortType", "PAY_LOW_TO_HI");
      setsortTypeText("Desired rate low to high");
      const obj = {
        _page: 1,
        _perPage: perPage,
        _sort: "PAY_LOW_TO_HI",
        search:
          props.value === 0
            ? ""
            : props.job_title
            ? props.job_title
            : props.value,

        NearBy: searchFilters.NearBy ? true : null,
        Latitude: localStorage.getItem("latitude")
          ? localStorage.getItem("latitude").toString()
          : null,
        Longitude: localStorage.getItem("longitude")
          ? localStorage.getItem("longitude").toString()
          : null,

        maxDistance: "50",
        hide: hideCheck ? true : null,

        BudgetMax: budget.budgetMax,
        BudgetMin: budget.budgetMin,
        BudgetType: budget.budgetType,
        GigType: jobTypeRadio,
        CityId: checkCityId,
        RegionId: checkRegionId,
        Location: checkRadioLoc,
        Experience: checkRadio,
      };
      const params = { obj };
      dispatch(skillListingCount(params));
    }
  };
  // kasjd
  const menu = (
    <Menu onClick={onClick}>
      <Menu.Item
        key="most_relevant"
        className={
          sortTypeText === "Most Relevant" && "sort-values-style-select"
        }
      >
        Most relevant
      </Menu.Item>
      <Menu.Item
        key="most_recent"
        className={sortTypeText === "New skill listing" && "sort-values-style-select"}
      >
        New skill listing
      </Menu.Item>

      <Menu.Item
        key="most_newest"
        className={sortTypeText === "Last Active" && "sort-values-style-select"}
      >
        Last active
      </Menu.Item>

      <Menu.Item
        key="ratings_high_to_low"
        className={
          sortTypeText === "Ratings High to Low" && "sort-values-style-select"
        }
      >
        Ratings high to low
      </Menu.Item>

      <Menu.Item
        key="ratings_low_to_high"
        className={
          sortTypeText === "Ratings Low to High" && "sort-values-style-select"
        }
      >
        Ratings low to high
      </Menu.Item>

        <Menu.Item
          key="PAY_HI_TO_LOW"
          className={
            sortTypeText === "Desired Rate High to Low" &&
            "sort-values-style-select"
          }
        >
          Desired rate high to low
        </Menu.Item>
        <Menu.Item
          key="PAY_LOW_TO_HI"
          className={
            sortTypeText === "Desired Rate Low to High" &&
            "sort-values-style-select"
          }
        >
          Desired rate low to high
        </Menu.Item>
    </Menu>
  );

  const filtersCounthandler = () => {
    if (filterError === "") {
      const obj = {
        _page: 1,
        _perPage: perPage,
        search:
          props.value === 0
            ? ""
            : props.job_title
            ? props.job_title
            : props.value,
        BudgetMax: budget.budgetMax,
        BudgetMin: budget.budgetMin,
        BudgetType: budget.budgetType,
        GigType: jobTypeRadio,
        Location: checkRadioLoc,
        // "Experience": checkRadio
      };
      const params = { obj };
      dispatch(skillListingCount(params));
    }
  };
  const checkFiltervalidity = () => {
    if (
      !checkRadioLoc &&
      !checkRadioRegion &&
      !checkRadioCountry &&
      !jobTypeRadio &&
      !budget.budgetMax &&
      !budget.budgetMin &&
      !budget.budgetType &&
      !checkRadio &&
      !hideCheck &&
      isformOpen
    ) {
      return true;
    } else return false;
  };

  const applyFilters = (type) => {
    setIsFormOpen(false);
    let canClose = true;
    // setPageNo(1);
    // removeQuery("pageNo");
    setCurrentPage(1);
    if (type !== "mobile") {
      if (type === "budget") {
        removeQuery("pageNo");
        if (
          budget.budgetMax &&
          budget.budgetMin &&
          +budget.budgetMax > +budget.budgetMin &&
          budget.budgetType
        ) {
          setPageNo(1);
          setFilter({
            budgetMax: budget.budgetMax,
            budgetMin: budget.budgetMin,
            budgetType: budget.budgetType,
          });
          addQuery("budgetMax", budget.budgetMax);
          addQuery("budgetMin", budget.budgetMin);
          addQuery("budgetType", budget.budgetType);
          setCloseModalBudget(false);
          setFilterError("");
          const obj = {
            _page: 1,
            _perPage: perPage,
            _sort: sortType,
            search:
              props.value === 0
                ? ""
                : props.job_title
                ? props.job_title
                : props.value,

            NearBy: searchFilters.NearBy ? true : null,
            Latitude: localStorage.getItem("latitude")
              ? localStorage.getItem("latitude").toString()
              : null,
            Longitude: localStorage.getItem("longitude")
              ? localStorage.getItem("longitude").toString()
              : null,

            maxDistance: "50",
            hide: hideCheck ? true : null,

            BudgetMax: budget.budgetMax ? budget.budgetMax : null,
            BudgetMin: budget.budgetMin ? budget.budgetMin : null,
            BudgetType: budget.budgetType ? budget.budgetType : null,
            GigType: jobTypeRadio ? jobTypeRadio : null,
            CityId: checkCityId,
            RegionId: checkRegionId,
            CountryId: checkCountryId,
            // Location: checkRadioLoc,
            Experience: checkBox.length ? checkBox : [],
            searchType: "Skills",
          };
          const params = { obj };
          // dispatch(skillListingCount(params));
          dispatch(skillListingTotalCount(params));
        } else {
          setFilter({ budgetMax: null, budgetMin: null, budgetType: null });
          setFilterError("budget");
          // setVisible(false);
        }
      }

      if (type === "jobType") {
        removeQuery("pageNo");
        setPageNo(1);
        if (jobTypeRadio) {
          setFilter({ skillListing_type: jobTypeRadio });
          setVisible(false);
          setCloseModalSkill(false);
          setFilterError("");
          addQuery("skillListing_type", jobTypeRadio);
          const obj = {
            _page: 1,
            _perPage: perPage,
            _sort: sortType,
            search:
              props.value === 0
                ? ""
                : props.job_title
                ? props.job_title
                : props.value,

            NearBy: searchFilters.NearBy ? true : null,
            Latitude: localStorage.getItem("latitude")
              ? localStorage.getItem("latitude").toString()
              : null,
            Longitude: localStorage.getItem("longitude")
              ? localStorage.getItem("longitude").toString()
              : null,

            maxDistance: "50",
            hide: hideCheck ? true : null,

            BudgetMax: budget.budgetMax,
            BudgetMin: budget.budgetMin,
            BudgetType: budget.budgetType,
            GigType: jobTypeRadio,
            CityId: checkCityId,
            RegionId: checkRegionId,
            CountryId: checkCountryId,
            // Location: checkRadioLoc,
            Experience: checkBox,
            searchType: "Skills",
          };
          const params = { obj };
          // dispatch(skillListingCount(params));
          dispatch(skillListingTotalCount(params));
        } else {
          setFilterError("jobtype");
        }
      }

      if (type === "city") {
        removeQuery("pageNo");
        setPageNo(1);
        if (checkCityId) {
          // setFilter({
          //   location: checkRadioLoc,
          //   cityId: checkCityId,
          // });
          setSearchFilters({
            ...searchFilters,
            cityId: checkCityId,
            location: checkRadioLoc,
          });
          setVisible(false);
          setCloseModalLoc(false);
          setFilterError("");
          addQuery("City", JSON.stringify(checkRadioLoc));
          addQuery("cityId", JSON.stringify(checkCityId));
          // addQuery("region", checkRegionId);
          const obj = {
            _page: 1,
            _perPage: perPage,
            _sort: sortType,
            search:
              props.value === 0
                ? ""
                : props.job_title
                ? props.job_title
                : props.value,

            NearBy: searchFilters.NearBy ? true : null,
            Latitude: localStorage.getItem("latitude")
              ? localStorage.getItem("latitude").toString()
              : null,
            Longitude: localStorage.getItem("longitude")
              ? localStorage.getItem("longitude").toString()
              : null,

            maxDistance: "50",
            hide: hideCheck ? true : null,

            BudgetMax: budget.budgetMax,
            BudgetMin: budget.budgetMin,
            BudgetType: budget.budgetType,
            GigType: jobTypeRadio,
            CityId: checkCityId,
            RegionId: checkRegionId,
            CountryId: checkCountryId,
            // Location: checkRadioLoc,
            Experience: checkBox,
            searchType: "Skills",
          };
          const params = { obj };
          // dispatch(skillListingCount(params));
          dispatch(skillListingTotalCount(params));
        } else {
          setFilterError("city");
        }
      }
      //region
      if (type === "region") {
        removeQuery("pageNo");
        setPageNo(1);
        if (checkRegionId) {
          // setFilter({
          //   region: checkRadioRegion,
          //   regionId: checkRegionId,
          // });
          setSearchFilters({
            ...searchFilters,
            regionId: checkRegionId,
            state: checkRadioRegion,
          });
          setVisible(false);
          setCloseModalRegion(false);
          setFilterError("");
          addQuery("Region", JSON.stringify(checkRadioRegion));
          addQuery("regionId", JSON.stringify(checkRegionId));
          const obj = {
            _page: 1,
            _perPage: perPage,
            _sort: sortType,
            search:
              props.value === 0
                ? ""
                : props.job_title
                ? props.job_title
                : props.value,

            NearBy: searchFilters.NearBy ? true : null,
            Latitude: localStorage.getItem("latitude")
              ? localStorage.getItem("latitude").toString()
              : null,
            Longitude: localStorage.getItem("longitude")
              ? localStorage.getItem("longitude").toString()
              : null,

            maxDistance: "50",
            hide: hideCheck ? true : null,

            BudgetMax: budget.budgetMax,
            BudgetMin: budget.budgetMin,
            BudgetType: budget.budgetType,
            GigType: jobTypeRadio,
            CityId: checkCityId,
            RegionId: checkRegionId,
            CountryId: checkCountryId,
            // Location: checkRadioLoc,
            Experience: checkBox,
            searchType: "Skills",
          };
          const params = { obj };
          // dispatch(skillListingCount(params));
          dispatch(skillListingTotalCount(params));
        } else {
          setFilterError("region");
        }
      }
      //state
      if (type === "country") {
        removeQuery("pageNo");
        setPageNo(1);
        if (checkCountryId) {
          // setFilter({
          //   state: checkRadioCountry,
          //   countryId: checkCountryId,
          // });
          setSearchFilters({
            ...searchFilters,
            countryId: checkCountryId,
            region: checkRadioCountry,
          });
          setVisible(false);
          setCloseModalState(false);
          setFilterError("");
          addQuery("Country", JSON.stringify(checkRadioCountry));
          addQuery("countryId", JSON.stringify(checkCountryId));
          const obj = {
            _page: 1,
            _perPage: perPage,
            _sort: sortType,
            search:
              props.value === 0
                ? ""
                : props.job_title
                ? props.job_title
                : props.value,

            NearBy: searchFilters.NearBy ? true : null,
            Latitude: localStorage.getItem("latitude")
              ? localStorage.getItem("latitude").toString()
              : null,
            Longitude: localStorage.getItem("longitude")
              ? localStorage.getItem("longitude").toString()
              : null,

            maxDistance: "50",
            hide: hideCheck ? true : null,

            BudgetMax: budget.budgetMax,
            BudgetMin: budget.budgetMin,
            BudgetType: budget.budgetType,
            GigType: jobTypeRadio,
            CityId: checkCityId,
            RegionId: checkRegionId,
            CountryId: checkCountryId,
            // Location: checkRadioLoc,
            Experience: checkBox,
            searchType: "Skills",
          };
          const params = { obj };
          // dispatch(skillListingCount(params));
          dispatch(skillListingTotalCount(params));
        } else {
          setFilterError("country");
        }
      }

      if (type === "company") {
        if (checkRadioCompany) {
          removeQuery("pageNo");
          setPageNo(1);
          setFilter({ company: checkRadioCompany });
          setVisible(false);
          setSearchFilters({ ...searchFilters, company: checkRadioCompany });
          setCloseModalCompany(false);
          setFilterError("");
          addQuery("Company", checkRadioCompany);
          const obj = {
            _page: 1,
            _perPage: perPage,
            _sort: sortType,
            search:
              props.value === 0
                ? ""
                : props.job_title
                ? props.job_title
                : props.value,

            NearBy: searchFilters.NearBy ? true : null,
            Latitude: localStorage.getItem("latitude")
              ? localStorage.getItem("latitude").toString()
              : null,
            Longitude: localStorage.getItem("longitude")
              ? localStorage.getItem("longitude").toString()
              : null,

            maxDistance: "50",
            hide: hideCheck ? true : null,

            BudgetMax: budget.budgetMax,
            BudgetMin: budget.budgetMin,
            BudgetType: budget.budgetType,
            GigType: jobTypeRadio,
            CityId: checkCityId,
            RegionId: checkRegionId,
            CountryId: checkCountryId,
            // Location: checkRadioLoc,
            Experience: checkRadio,
            searchType: "Skills",
          };
          const params = { obj };
          // dispatch(skillListingCount(params));
          dispatch(skillListingTotalCount(params));
        } else {
          setFilterError("company");
        }
      }

      if (type === "industry") {
        if (checkRadioIndustry.length) {
          removeQuery("pageNo");
          setPageNo(1);
          setFilter({
            ...searchFilters,
            industry: checkRadioIndustry,
            industryId: checkIndustryId,
          });
          setVisible(false);
          setCloseModalPrev(false);
          setFilterError("");
          addQuery("Industry", JSON.stringify(checkRadioIndustry));
          addQuery("industryId", JSON.stringify(checkIndustryId));
          const obj = {
            _page: 1,
            _perPage: perPage,
            _sort: sortType,
            search:
              props.value === 0
                ? ""
                : props.job_title
                ? props.job_title
                : props.value,

            NearBy: searchFilters.NearBy ? true : null,
            Latitude: localStorage.getItem("latitude")
              ? localStorage.getItem("latitude").toString()
              : null,
            Longitude: localStorage.getItem("longitude")
              ? localStorage.getItem("longitude").toString()
              : null,

            maxDistance: "50",
            hide: hideCheck ? true : null,

            BudgetMax: budget.budgetMax,
            BudgetMin: budget.budgetMin,
            BudgetType: budget.budgetType,
            GigType: jobTypeRadio,
            CityId: checkCityId,
            RegionId: checkRegionId,
            CountryId: checkCountryId,
            // Location: checkRadioLoc,
            Experience: checkRadio,
            searchType: "Skills",
          };
          const params = { obj };
          // dispatch(skillListingCount(params));
          dispatch(skillListingTotalCount(params));
        } else {
          setFilterError("industry");
        }
      }

      if (type === "visa") {
        if (checkRadioVisa) {
          setPageNo(1);
          removeQuery("pageNo");
          setFilter({ visa: checkRadioVisa });
          setFilter({ visaName: checkRadioVisaName });
          setVisible(false);
          setCloseModalVisa(false);
          setFilterError("");
          addQuery("VisaStatusId", JSON.stringify(checkRadioVisa));
          addQuery("VisaName", JSON.stringify(checkRadioVisaName));
        } else {
          setFilterError("visa");
        }
      }

      if (type === "city") {
        if (checkRadioLoc.length) {
          removeQuery("pageNo");
          setPageNo(1);
          // setFilter({
          //   location: checkRadioLoc,
          //   cityId: checkCityId,
          // });
          setSearchFilters({
            ...searchFilters,
            cityId: checkCityId,
            location: checkRadioLoc,
          });
          setVisible(false);
          setCloseModalLoc(false);
          setFilterError("");
          addQuery("City", JSON.stringify(checkRadioLoc));
          addQuery("cityId", JSON.stringify(checkCityId));
          const obj = {
            _page: 1,
            _perPage: perPage,
            _sort: sortType,
            search:
              props.value === 0
                ? ""
                : props.job_title
                ? props.job_title
                : props.value,

            NearBy: searchFilters.NearBy ? true : null,
            Latitude: localStorage.getItem("latitude")
              ? localStorage.getItem("latitude").toString()
              : null,
            Longitude: localStorage.getItem("longitude")
              ? localStorage.getItem("longitude").toString()
              : null,

            maxDistance: "50",
            hide: hideCheck ? true : null,

            BudgetMax: budget.budgetMax,
            BudgetMin: budget.budgetMin,
            BudgetType: budget.budgetType,
            GigType: jobTypeRadio,
            CityId: checkCityId,
            RegionId: checkRegionId,
            CountryId: checkCountryId,
            // Location: checkRadioLoc,
            Experience: checkBox, //checkRadio
            searchType: "Skills",
          };
          const params = { obj };
          // dispatch(skillListingCount(params));
          dispatch(skillListingTotalCount(params));
        } else {
          setFilterError("city");
        }
      }

      if (type === "experience") {
        removeQuery("pageNo");
        setPageNo(1);
        if (checkBox.length) {
          setFilter({ ExperienceLevel: checkBox });
          setVisible(false);
          setCloseModalExp(false);
          setFilterError("");
          addQuery("experience", JSON.stringify(checkBox));

          const obj = {
            _page: 1,
            _perPage: perPage,
            _sort: sortType,
            search:
              props.value === 0
                ? ""
                : props.job_title
                ? props.job_title
                : props.value,

            NearBy: searchFilters.NearBy ? true : null,
            Latitude: localStorage.getItem("latitude")
              ? localStorage.getItem("latitude").toString()
              : null,
            Longitude: localStorage.getItem("longitude")
              ? localStorage.getItem("longitude").toString()
              : null,

            maxDistance: "50",
            hide: hideCheck ? true : null,

            BudgetMax: budget.budgetMax,
            BudgetMin: budget.budgetMin,
            BudgetType: budget.budgetType,
            GigType: jobTypeRadio,
            CityId: checkCityId,
            RegionId: checkRegionId,
            CountryId: checkCountryId,
            // Location: checkRadioLoc,
            Experience: checkBox,
            searchType: "Skills",
          };
          const params = { obj };
          // dispatch(skillListingCount(params));
          dispatch(skillListingTotalCount(params));
        } else {
          setFilterError("experience");
        }
      }

      // if (closeModalSkill) {
      //   setCloseModalSkill(false);
      // }
      // if (closeModalLoc) {
      //   setCloseModalLoc(false);
      // }
      // if (closeModalBudget) {
      //   setCloseModalBudget(false);
      // }
      // if (closeModalExp) {
      //   setCloseModalExp(false);
      // }
    } else {
      setIsFormOpen(true);
      setFilterError("");
      if (
        !checkRadioLoc &&
        !checkRadioRegion &&
        !checkRadioCountry &&
        !jobTypeRadio &&
        !budget.budgetMax &&
        !budget.budgetMin &&
        !budget.budgetType &&
        checkBox.length == 0 &&
        !hideCheck
      ) {
        // setFilterError('NoFilter')
        canClose = false;
      } else {
        canClose = true;
        setFilterError("");
      }

      if (checkBox.length) {
        removeQuery("pageNo");
        setPageNo(1);
        setFilter({ ExperienceLevel: checkBox });
        addQuery("experience", JSON.stringify(checkBox));
        const obj = {
          _page: 1,
          _perPage: perPage,
          _sort: sortType,
          search:
            props.value === 0
              ? ""
              : props.job_title
              ? props.job_title
              : props.value,

          NearBy: searchFilters.NearBy ? true : null,
          Latitude: localStorage.getItem("latitude")
            ? localStorage.getItem("latitude").toString()
            : null,
          Longitude: localStorage.getItem("longitude")
            ? localStorage.getItem("longitude").toString()
            : null,

          maxDistance: "50",
          hide: hideCheck ? true : null,

          BudgetMax: budget.budgetMax,
          BudgetMin: budget.budgetMin,
          BudgetType: budget.budgetType,
          GigType: jobTypeRadio,
          CityId: checkCityId,
          RegionId: checkRegionId,
          CountryId: checkCountryId,
          // Location: checkRadioLoc,
          Experience: checkBox,
          searchType: "Skills",
        };
        const params = { obj };
        // dispatch(skillListingCount(params));
        dispatch(skillListingTotalCount(params));
      }

      if (
        budget.budgetMax &&
        budget.budgetMin &&
        budget.budgetMax > budget.budgetMin
      ) {
        removeQuery("pageNo");
        setPageNo(1);
        setFilter({
          budgetMax: budget.budgetMax,
          budgetMin: budget.budgetMin,
          budgetType: budget.budgetType,
        });
        addQuery("budgetMax", budget.budgetMax);
        addQuery("budgetMin", budget.budgetMin);
        addQuery("budgetType", budget.budgetType);
        const obj = {
          _page: 1,
          _perPage: perPage,
          _sort: sortType,
          search:
            props.value === 0
              ? ""
              : props.job_title
              ? props.job_title
              : props.value,

          NearBy: searchFilters.NearBy ? true : null,
          Latitude: localStorage.getItem("latitude")
            ? localStorage.getItem("latitude").toString()
            : null,
          Longitude: localStorage.getItem("longitude")
            ? localStorage.getItem("longitude").toString()
            : null,

          maxDistance: "50",
          hide: hideCheck ? true : null,

          BudgetMax: budget.budgetMax,
          BudgetMin: budget.budgetMin,
          BudgetType: budget.budgetType,
          GigType: jobTypeRadio,
          CityId: checkCityId,
          RegionId: checkRegionId,
          CountryId: checkCountryId,
          // Location: checkRadioLoc,
          Experience: checkBox,
          searchType: "Skills",
        };
        const params = { obj };
        // dispatch(skillListingCount(params));
        dispatch(skillListingTotalCount(params));
      }

      if (jobTypeRadio) {
        removeQuery("pageNo");
        setPageNo(1);
        setFilter({ skillListing_type: jobTypeRadio });
        addQuery("skillListing_type", jobTypeRadio);
        const obj = {
          _page: 1,
          _perPage: perPage,
          _sort: sortType,
          search:
            props.value === 0
              ? ""
              : props.job_title
              ? props.job_title
              : props.value,

          NearBy: searchFilters.NearBy ? true : null,
          Latitude: localStorage.getItem("latitude")
            ? localStorage.getItem("latitude").toString()
            : null,
          Longitude: localStorage.getItem("longitude")
            ? localStorage.getItem("longitude").toString()
            : null,

          maxDistance: "50",
          hide: hideCheck ? true : null,

          BudgetMax: budget.budgetMax,
          BudgetMin: budget.budgetMin,
          BudgetType: budget.budgetType,
          GigType: jobTypeRadio,
          CityId: checkCityId,
          RegionId: checkRegionId,
          CountryId: checkCountryId,
          // Location: checkRadioLoc,
          Experience: checkBox,
          searchType: "Skills",
        };
        const params = { obj };
        // dispatch(skillListingCount(params));
        dispatch(skillListingTotalCount(params));
      }

      if (checkRadioLoc) {
        removeQuery("pageNo");
        setPageNo(1);
        setSearchFilters({
          location: [...searchFilters.location, checkRadioLoc],
        });
        addQuery("City", JSON.stringify(checkRadioLoc));
        addQuery("cityId", JSON.stringify(checkCityId));

        const obj = {
          _page: 1,
          _perPage: perPage,
          _sort: sortType,
          search:
            props.value === 0
              ? ""
              : props.job_title
              ? props.job_title
              : props.value,

          NearBy: searchFilters.NearBy ? true : null,
          Latitude: localStorage.getItem("latitude")
            ? localStorage.getItem("latitude").toString()
            : null,
          Longitude: localStorage.getItem("longitude")
            ? localStorage.getItem("longitude").toString()
            : null,

          maxDistance: "50",
          hide: hideCheck ? true : null,

          BudgetMax: budget.budgetMax,
          BudgetMin: budget.budgetMin,
          BudgetType: budget.budgetType,
          GigType: jobTypeRadio,
          CityId: checkCityId,
          RegionId: checkRegionId,
          CountryId: checkCountryId,
          // Location: checkRadioLoc,
          Experience: checkBox,
          searchType: "Skills",
        };
        const params = { obj };
        // dispatch(skillListingCount(params));
        dispatch(skillListingTotalCount(params));
      }

      if (
        checkRadioIndustry &&
        userProfile?.Professions?.ProfessionCode === "IT"
      ) {
        removeQuery("pageNo");
        setPageNo(1);
        setFilter({
          ...searchFilters,
          industry: checkRadioIndustry,
          industryId: checkIndustryId,
        });
        setCloseModalPrev(false);
        setFilterError("");
        addQuery("Industry", JSON.stringify(checkRadioIndustry));
        addQuery("industryId", JSON.stringify(checkIndustryId));
        const obj = {
          _page: 1,
          _perPage: perPage,
          _sort: sortType,
          search:
            props.value === 0
              ? ""
              : props.job_title
              ? props.job_title
              : props.value,

          NearBy: searchFilters.NearBy ? true : null,
          Latitude: localStorage.getItem("latitude")
            ? localStorage.getItem("latitude").toString()
            : null,
          Longitude: localStorage.getItem("longitude")
            ? localStorage.getItem("longitude").toString()
            : null,

          maxDistance: "50",
          hide: hideCheck ? true : null,

          BudgetMax: budget.budgetMax,
          BudgetMin: budget.budgetMin,
          BudgetType: budget.budgetType,
          GigType: jobTypeRadio,
          CityId: checkCityId,
          RegionId: checkRegionId,
          CountryId: checkCountryId,
          // Location: checkRadioLoc,
          Experience: checkBox,
          searchType: "Skills",
        };
        const params = { obj };
        dispatch(skillListingTotalCount(params));

        setVisible(false);
      } else {
        setFilterError("industry");
      }
      //company

      if (checkRadioCompany) {
        removeQuery("pageNo");
        setPageNo(1);
        setFilter({ company: checkRadioCompany });
        setFilterError("");
        const obj = {
          _page: 1,

          _perPage: perPage,

          _sort: sortType,

          search:
            props.value === 0
              ? ""
              : props.job_title
              ? props.job_title
              : props.value,

          NearBy: searchFilters.NearBy ? true : null,

          Latitude: localStorage.getItem("latitude")
            ? localStorage.getItem("latitude").toString()
            : null,

          Longitude: localStorage.getItem("longitude")
            ? localStorage.getItem("longitude").toString()
            : null,

          maxDistance: "50",

          hide: hideCheck ? true : null,

          BudgetMax: budget.budgetMax,

          BudgetMin: budget.budgetMin,

          BudgetType: budget.budgetType,

          GigType: jobTypeRadio,

          CityId: checkCityId,

          RegionId: checkRegionId,

          CountryId: checkCountryId,

          // Location: checkRadioLoc,

          Experience: checkRadio,

          searchType: "Skills",
        };
        const params = { obj };
        // dispatch(skillListingCount(params));
        dispatch(skillListingTotalCount(params));
        addQuery("Company", checkRadioCompany);
        setVisible(false);
      } else {
        setFilterError("company");
      }

      if (checkRadioVisa) {
        removeQuery("pageNo");
        setPageNo(1);
        setFilter({ visa: checkVisaIdArray });
        // setFilter({ visaName: checkRadioVisaName });
        setFilterError("");
        const obj = {
          _page: 1,

          _perPage: perPage,

          _sort: sortType,

          search:
            props.value === 0
              ? ""
              : props.job_title
              ? props.job_title
              : props.value,

          NearBy: searchFilters.NearBy ? true : null,

          Latitude: localStorage.getItem("latitude")
            ? localStorage.getItem("latitude").toString()
            : null,

          Longitude: localStorage.getItem("longitude")
            ? localStorage.getItem("longitude").toString()
            : null,

          maxDistance: "50",

          hide: hideCheck ? true : null,

          BudgetMax: budget.budgetMax,

          BudgetMin: budget.budgetMin,

          BudgetType: budget.budgetType,

          GigType: jobTypeRadio,

          CityId: checkCityId,

          RegionId: checkRegionId,

          CountryId: checkCountryId,

          // Location: checkRadioLoc,

          Experience: checkRadio,

          searchType: "SKills",
        };
        const params = { obj };
        // dispatch(skillListingCount(params));
        dispatch(skillListingTotalCount(params));
        addQuery("VisaStatusId", JSON.stringify(checkVisaIdArray));
          // addQuery("VisaName", JSON.stringify(checkRadioVisaName));
        setVisible(false);
      } else {
        setFilterError("visa");
      }


      //region
      if (checkRadioRegion) {
        removeQuery("pageNo");
        setPageNo(1);
        setFilter({
          region: checkRadioRegion,
          regionId: checkRegionId,
        });
        addQuery("Region", JSON.stringify(checkRadioRegion));
        addQuery("regionId", JSON.stringify(checkRegionId));
        const obj = {
          _page: 1,
          _perPage: perPage,
          _sort: sortType,
          search:
            props.value === 0
              ? ""
              : props.job_title
              ? props.job_title
              : props.value,

          NearBy: searchFilters.NearBy ? true : null,
          Latitude: localStorage.getItem("latitude")
            ? localStorage.getItem("latitude").toString()
            : null,
          Longitude: localStorage.getItem("longitude")
            ? localStorage.getItem("longitude").toString()
            : null,

          maxDistance: "50",
          hide: hideCheck ? true : null,

          BudgetMax: budget.budgetMax,
          BudgetMin: budget.budgetMin,
          BudgetType: budget.budgetType,
          GigType: jobTypeRadio,
          CityId: checkCityId,
          RegionId: checkRegionId,
          CountryId: checkCountryId,
          // Location: checkRadioLoc,
          Experience: checkBox,
          searchType: "Skills",
        };
        const params = { obj };
        // dispatch(skillListingCount(params));
        dispatch(skillListingTotalCount(params));
      }

      //state
      if (checkRadioCountry) {
        removeQuery("pageNo");
        setPageNo(1);
        
        setFilter({
          state: checkRadioCountry,
          countryId: checkCountryId,
        });
        addQuery("Country", JSON.stringify(checkRadioCountry));
        addQuery("countryId", JSON.stringify(checkCountryId));
        const obj = {
          _page: 1,
          _perPage: perPage,
          _sort: sortType,
          search:
            props.value === 0
              ? ""
              : props.job_title
              ? props.job_title
              : props.value,

          NearBy: searchFilters.NearBy ? true : null,
          Latitude: localStorage.getItem("latitude")
            ? localStorage.getItem("latitude").toString()
            : null,
          Longitude: localStorage.getItem("longitude")
            ? localStorage.getItem("longitude").toString()
            : null,

          maxDistance: "50",
          hide: hideCheck ? true : null,

          BudgetMax: budget.budgetMax,
          BudgetMin: budget.budgetMin,
          BudgetType: budget.budgetType,
          GigType: jobTypeRadio,
          CityId: checkCityId,
          RegionId: checkRegionId,
          CountryId: checkCountryId,
          // Location: checkRadioLoc,
          Experience: checkBox,
          searchType: "Skills",
        };
        const params = { obj };
        // dispatch(skillListingCount(params));
        dispatch(skillListingTotalCount(params));
      }
      if (hideCheck) {
        removeQuery("pageNo");
        setPageNo(1);
        setFilter({ hidePrevious: true });
        const obj = {
          _page: 1,
          _perPage: perPage,
          _sort: sortType,
          search:
            props.value === 0
              ? ""
              : props.job_title
              ? props.job_title
              : props.value,

          NearBy: searchFilters.NearBy ? true : null,
          Latitude: localStorage.getItem("latitude")
            ? localStorage.getItem("latitude").toString()
            : null,
          Longitude: localStorage.getItem("longitude")
            ? localStorage.getItem("longitude").toString()
            : null,

          maxDistance: "50",
          hide: true,

          BudgetMax: budget.budgetMax,
          BudgetMin: budget.budgetMin,
          BudgetType: budget.budgetType,
          GigType: jobTypeRadio,
          CityId: checkCityId,
          RegionId: checkRegionId,
          CountryId: checkCountryId,
          // Location: checkRadioLoc,
          Experience: checkBox,
          searchType: "Skills",
        };
        const params = { obj };
        // dispatch(skillListingCount(params));
        dispatch(skillListingTotalCount(params));
      }

      if (!hideCheck) {
        removeQuery("pageNo");
        setPageNo(1);
        setFilterError("");
        setFilter({ hidePrevious: null });
        const obj = {
          _page: 1,
          _perPage: perPage,
          search:
            props.value === 0
              ? ""
              : props.job_title
              ? props.job_title
              : props.value,
          hide: null,
        };
        const params = { obj };
        dispatch(skillListingCount(params));
      }
    }

    if (canClose) {
      removeQuery("pageNo");
      setPageNo(1);
      setVisible(false);
    }
  };

  const SortResults = () => {
    removeQuery("pageNo");
    setSortType(window.sort);
    addQuery("sortType", window.sort);
    setPageNo(1);
    setCurrentPage(1);

    debounce(hitQuery());
    setSortVisible(false);

    const obj = {
      _page: 1,
      _perPage: perPage,
      _sort: window.sort,
      search:
        props.value === 0
          ? ""
          : props.job_title
          ? props.job_title
          : props.value,

      NearBy: searchFilters.NearBy ? true : null,
      Latitude: localStorage.getItem("latitude")
        ? localStorage.getItem("latitude").toString()
        : null,
      Longitude: localStorage.getItem("longitude")
        ? localStorage.getItem("longitude").toString()
        : null,
      maxDistance: "50",
      hide: hideCheck ? true : null,

      BudgetMax: budget.budgetMax,
      BudgetMin: budget.budgetMin,
      BudgetType: budget.budgetType,
      GigType: jobTypeRadio,
      CityId: checkCityId,
      RegionId: checkRegionId,
      Location: checkRadioLoc,
      Experience: checkRadio,
    };
    const params = { obj };
    dispatch(skillListingCount(params));
  };

  const onChangePage = (page, pageSize) => {
    setSearchFilters({ ...searchFilters, _page: page })
    hitQuery()
    addQuery("pageNo", page);
    setPageNo(page);
    setCurrentPage(page);
    setPerPage(pageSize);
    setSkillListingIds(typeof LocalSelectedSkillListings === "string" ? JSON.parse(LocalSelectedSkillListings) : LocalSelectedSkillListings)
    setcheckAllClicked(false);
    setSelectText(true);
  };

  const mylocation = () => {
    removeQuery("pageNo");

    let check = locationCheck;
    setLocationCheck(!check);
    if (!check) {
      addQuery("nearby", true);
    } else {
      removeQuery("nearby");
    }
    setPageNo(1);
    setCurrentPage(1);
    var watchID = "";
    if (searchFilters.NearBy) {
      setFilter({ NearBy: null });

      {
        /* setLatitude();
       setLongitude(); */
      }
      navigator.geolocation.clearWatch(watchID);
      const obj = {
        _page: 1,
        _perPage: perPage,
        _sort: sortType,
        search: props.value,
        hide: hideCheck ? true : null,
        NearBy: null,
        Latitude: null,
        Longitude: null,
        BudgetMax: budget.budgetMax,
        BudgetMin: budget.budgetMin,
        BudgetType: budget.budgetType,
        GigType: jobTypeRadio,
        CityId: checkCityId,
        RegionId: checkRegionId,
        CountryId: checkCountryId,
        // Location: checkRadioLoc,
        Experience: checkBox,
        searchType: "Skills",
      };
      const params = { obj };
      // dispatch(skillListingCount(params));
      dispatch(skillListingTotalCount(params));
    } else {
      if (navigator.geolocation) {
        watchID = navigator.geolocation.watchPosition(function (position) {
          setFilter({ NearBy: true });
          localStorage.setItem("latitude", position.coords.latitude);
          localStorage.setItem("longitude", position.coords.longitude);
          setLatitude(position.coords.latitude);
          setLongitude(position.coords.longitude);

          // return;
          const obj = {
            _page: 1,
            _perPage: perPage,
            _sort: sortType,
            search:
              props.value === 0
                ? ""
                : props.job_title
                ? props.job_title
                : props.value,
            NearBy: true,
            Latitude: position.coords.latitude.toString(),
            Longitude: position.coords.longitude.toString(),
            maxDistance: "50",

            hide: hideCheck ? true : null,

            BudgetMax: budget.budgetMax,
            BudgetMin: budget.budgetMin,
            BudgetType: budget.budgetType,
            GigType: jobTypeRadio,
            CityId: checkCityId,
            RegionId: checkRegionId,
            CountryId: checkCountryId,
            // Location: checkRadioLoc,
            Experience: checkBox,
            searchType: "Skills",
          };
          const params = { obj };

          // dispatch(skillListingCount(params));
          dispatch(skillListingTotalCount(params));
          return;
        });
        let latitudeData = localStorage.getItem("latitude").toString();
        let longitudeData = localStorage.getItem("longitude").toString();

        setFilter({ NearBy: true });
        const obj = {
          _page: 1,
          _perPage: perPage,
          _sort: sortType,
          search:
            props.value === 0
              ? ""
              : props.job_title
              ? props.job_title
              : props.value,
          NearBy: true,
          Latitude: latitudeData,
          Longitude: longitudeData,
          maxDistance: "50",

          hide: hideCheck ? true : null,

          BudgetMax: budget.budgetMax,
          BudgetMin: budget.budgetMin,
          BudgetType: budget.budgetType,
          GigType: jobTypeRadio,
          CityId: checkCityId,
          RegionId: checkRegionId,
          CountryId: checkCountryId,
          // Location: checkRadioLoc,
          Experience: checkBox,
          searchType: "Skills",
        };
        const params = { obj };

        // dispatch(skillListingCount(params));
        dispatch(skillListingTotalCount(params));
      }
    }
  };

  function mergeArrays(array1, array2) {
    const uniqueObjects = {}; // Object to track unique IDs
    const resultArray = [];
  
    // Merge array1
    for (const obj of array1) {
      if (!uniqueObjects[obj.SkillListingId]) {
        uniqueObjects[obj.SkillListingId] = true; // Mark ID as seen
        resultArray.push(obj);
      }
    }
  
    // Merge array2
    for (const obj of array2) {
      if (!uniqueObjects[obj.SkillListingId]) {
        uniqueObjects[obj.SkillListingId] = true; // Mark ID as seen
        resultArray.push(obj);
      }
    }
  
    return resultArray;
  }

  function setLocalStorage(key,value){
    localStorage.setItem(key,JSON.stringify(value));
  }
  
  const onCheckAllChange = (e) => {
    
    var myarr = [];
    if(!checkAllClicked){
      if (e.target.checked) {
        myarr = skillListings.skilllistings.data.filter(
          (data) => data.bidstatus == false
        );
        
      }
      // let allSelectedSkillListngs = LocalSelectedSkillListings?.length ? [...LocalSelectedSkillListings,...myarr] : myarr
      let allSelectedSkillListngs = mergeArrays(LocalSelectedSkillListings?.length ? LocalSelectedSkillListings : myarr,myarr);
      setSkillListingIds(allSelectedSkillListngs.slice(0, 24));
      localStorage.setItem("SelectedSkills",JSON.stringify(allSelectedSkillListngs.slice(0, 24)))
    }
    else{
      setSkillListingIds(myarr);
      localStorage.setItem("SelectedSkills",JSON.stringify(myarr))
    }
    setcheckAllClicked(e.target.checked);
    // setSkillListingIds(myarr);
    setSelectText(!selectText);
  };

  useEffect(()=>{
    if(LocalSelectedSkillListings == null){
      setSkillListingIds(typeof LocalSelectedSkillListings === "string" ? JSON.parse(LocalSelectedSkillListings) : LocalSelectedSkillListings);
    }
  },[LocalSelectedSkillListings])

  const onSearch = (e) => {
    props.searchValue(e);
  };
  const placeBid = () => {
    var candidateslistArray = [];
    for (var i = 0; i < skillListingIds.length; ++i) {
      candidateslistArray.push({
        id: skillListingIds[i].SkillListingId,
        img: skillListingIds[i]?.users?.Profiles?.PictureUrl,
        AccountId: skillListingIds[i]?.CreatedBy,
        name: skillListingIds[i]?.users?.Profiles?.FirstName
          ? skillListingIds[i]?.users?.Profiles?.FirstName +
            "\n" +
            skillListingIds[i]?.users?.Profiles?.LastName
          : skillListingIds[i]?.users?.UserName
          ? skillListingIds[i]?.users?.UserName
          : "Candidate name",

        email: skillListingIds[i]?.users?.EmailAddress
          ? skillListingIds[i]?.users?.EmailAddress
          : "Email address",

        rating:
          skillListingIds[i]?.users?.Profiles?.Rating == null ||
          skillListingIds[i]?.users?.Profiles?.Rating == "" ||
          skillListingIds[i]?.users?.Profiles?.Rating == undefined
            ? 3.5
            : skillListingIds[i]?.users?.Profiles?.Rating,

        reviews:
          skillListingIds[i]?.users?.Profiles?.Review == null ||
          skillListingIds[i]?.users?.Profiles?.Review == "" ||
          skillListingIds[i]?.users?.Profiles?.Review == undefined
            ? "(493)"
            : "(" + skillListingIds[i]?.users?.Profiles?.Review + ")",
        experience:
          skillListingIds[i]?.explevel[0]?.ExperienceLevelName &&
          skillListingIds[i]?.explevel[0]?.ExperienceLevelName != null &&
          skillListingIds[i]?.explevel[0]?.ExperienceLevelName != "" &&
          skillListingIds[i]?.explevel[0]?.ExperienceLevelName != undefined
            ? skillListingIds[i]?.explevel[0]?.ExperienceLevelName
            : "N/A",
        //  skillListingIds[i].explevel[0]?.ExperienceLevelName ?
        // skillListingIds[i]?.explevel[0]?.ExperienceLevelName
        // : 'N/A',

        title: skillListingIds[i]?.Title,
        desired_rate: skillListingIds[i]?.MinimumBid?.$numberDecimal
          ? skillListingIds[i]?.MinimumBid?.$numberDecimal?.slice(0, -3)
          : skillListingIds[i]?.MinimumBid
          ? skillListingIds[i]?.MinimumBid
          : "Negotiable",
        //skillListingIds[i]?.MinimumBid,
        bidType:
          skillListingIds[i].BudgetTypes &&
          skillListingIds[i].BudgetTypes?.BudgetTypeName != null &&
          skillListingIds[i].BudgetTypes?.BudgetTypeName != "" &&
          skillListingIds[i].BudgetTypes?.BudgetTypeName != undefined
            ? skillListingIds[i].BudgetTypes?.BudgetTypeName
            : "/N/A",
        //skillListingIds[i]?.MinimumBidType,
        profileType: profileTypeRes?.profile?.ProfessionCode,
        lastActive:
          skillListingIds[i]?.users?.LastSuccessfulLoginDate != null
            ? moment(
                skillListingIds[i]?.users?.LastSuccessfulLoginDate
              ).fromNow()
            : "N/A",
        // Rating : skillListingIds[i]?
      });
    }
    setcandidateList(candidateslistArray);
    setplacebidModal(true);
  };

  const placeBidModalVisisblityHandler = (value) => {
    setplacebidModal(value);
  };

  const hidePreviousFunc = (e) => {
    removeQuery("pageNo");
    setCurrentPage(1);
    setPageNo(1);
    addQuery("hide", true);
    if (hideCheck) {
      setHideCheck(false);
      setSearchFilters({ ...searchFilters, hidePrevious: null });
      removeQuery("hide");

      const obj = {
        _page: 1,
        _perPage: perPage,
        _sort: sortType,
        search:
          props.value === 0
            ? ""
            : props.job_title
            ? props.job_title
            : props.value,
        hide: null,

        NearBy: searchFilters.NearBy ? true : null,
        Latitude: localStorage.getItem("latitude")
          ? localStorage.getItem("latitude").toString()
          : null,
        Longitude: localStorage.getItem("longitude")
          ? localStorage.getItem("longitude").toString()
          : null,

        maxDistance: "50",

        BudgetMax: budget.budgetMax,
        BudgetMin: budget.budgetMin,
        BudgetType: budget.budgetType,
        GigType: jobTypeRadio,
        CityId: checkCityId,
        RegionId: checkRegionId,
        CountryId: checkCountryId,
        // Location: checkRadioLoc,
        Experience: checkBox,
        searchType: "Skills",
      };
      const params = { obj };
      // dispatch(skillListingCount(params));
      dispatch(skillListingTotalCount(params));
    } else {
      setHideCheck(true);
      setSearchFilters({ ...searchFilters, hidePrevious: true });

      const obj = {
        _page: 1,
        _perPage: perPage,
        _sort: sortType,
        search:
          props.value === 0
            ? ""
            : props.job_title
            ? props.job_title
            : props.value,
        hide: true,

        NearBy: searchFilters.NearBy ? true : null,
        Latitude: localStorage.getItem("latitude")
          ? localStorage.getItem("latitude").toString()
          : null,
        Longitude: localStorage.getItem("longitude")
          ? localStorage.getItem("longitude").toString()
          : null,

        maxDistance: "50",

        BudgetMax: budget.budgetMax,
        BudgetMin: budget.budgetMin,
        BudgetType: budget.budgetType,
        GigType: jobTypeRadio,
        CityId: checkCityId,
        RegionId: checkRegionId,
        CountryId: checkCountryId,
        // Location: checkRadioLoc,
        Experience: checkBox,
        searchType: "Skills",
      };
      const params = { obj };
      // dispatch(skillListingCount(params));
      dispatch(skillListingTotalCount(params));
    }

    // if (searchFilters.hidePrevious === null) {
    //   setSearchFilters({ ...searchFilters, hidePrevious: true })
    //   setHideCheck(e.target.value)
    // }
    // else {
    //   setSearchFilters({ ...searchFilters, hidePrevious: null })
    //   setHideCheck(null)
    // }
  };

  // ***********************************
  useEffect(() => {
    if (searchBarcalled) {
      setFilterCount(0);
      // removeQuery("location");
      removeQuery("City");
      removeQuery("Region");
      removeQuery("Country");
      removeQuery("skillListing_type");
      removeQuery("experience");
      removeQuery("budgetMax");
      removeQuery("budgetMin");
      removeQuery("budgetType");
      removeQuery("cityId");
      removeQuery("regionId");
      removeQuery("countryId");
      removeQuery("pageNo");
      setSearchBarcalled(false);
    }
  }, [searchBarcalled]);
  // ***********************************
  // ***********************************

  const onCloseSortModal = () => {
    setSortVisible(false);
  };

  const onCloseFiltersModal = () => {
    setFilterError("");
    setIsFormOpen(false);
    setVisible(false);
  };

  const handleCityChange = (flag) => {
    if (flag) {
      if (emptyCityInput === "") {
        setEmptyCityInput();
      }
    }
    // if (!flag) {
    // setEmptyCityInput('')
    // }
    setVisible(flag);
  };

  const handleRegionChange = (flag) => {
    if (flag) {
      if (emptyRegionInput === "") {
        setEmptyRegionInput();
      }
    }
    // if (!flag) {
    //    setEmptyRegionInput('')
    // }
    setVisible(flag);
  };

  const handleCountryChange = (flag) => {
    if (flag) {
      if (emptyCountryInput === "") {
        setEmptyCountryInput();
      }
    }
    // if (!flag) {
    //   setEmptyCountryInput('')
    // }
    setVisible(flag);
  };
  useEffect(() => {
    if (closeModalLoc) {
      const queryparams = GetQueryParams();
      let cleanparam = queryparams?.cityId?.slice(1, -1);
      let array = cleanparam?.split(",");
      array = array?.map(Number);
      array?.length > 0 ? setCheckCityId(array) : setCheckCityId([]);
    }
  }, [closeModalLoc]);

  //for state
  useEffect(() => {
    if (closeModalRegion) {
      const queryparams = GetQueryParams();
      let cleanparam = queryparams?.regionId?.slice(1, -1);
      let array = cleanparam?.split(",");
      array = array?.map(Number);
      array?.length > 0 ? setCheckRegionId(array) : setCheckRegionId([]);
    }
  }, [closeModalRegion]);

  //for country
  useEffect(() => {
    if (closeModalState) {
      const queryparams = GetQueryParams();
      let cleanparam = queryparams?.countryId?.slice(1, -1);
      let array = cleanparam?.split(",");
      array = array?.map(Number);
      array?.length ? setCheckCountryId(array) : setCheckCountryId([]);
    }
  }, [closeModalState]);

  return (
    <React.Fragment>
      {!HidePagePvt ? <>
      {!props.job_title ? (
        <Search_Bar searchBarcalled={setSearchBarcalled} />
      ) : null}
      <main className="candidateMarket-dashBoardFull">
        {
          <div className={"results_descriptiontext"}>
            {props.job_title && (
              <div style={{ marginBottom: "1rem" }}>
                Suggested best matches to your gig
              </div>
            )}

            {props.job_title &&
              skillListings?.skilllistings?.data?.length > 0 && (
                <div>
                  {" "}
                  {currentPage * perPage - perPage + 1} -{" "}
                  {currentPage * perPage} out of&nbsp;
                  {skillListings?.skilllistings?.data?.[0].TotalCount?.count?.total ||0 }{" "}
                </div>
              )}
          </div>
        }
        {/* <Col
          xs={24}
          className={
            windowDimensions.width < 769
              ? "suggestion-wrdapper-mobile"
              : "suggestion-wrdapper"
          }
        >
          {suggestions.skillsListing
            ? suggestions.skillsListing.map(( suggesteditems) => {
              // if(index <=3)a
                return (
                  <Tag
                    color="default"
                    className={"tags"}
                    style={{cursor:'pointer'}}
                    onClick={() => onSearch(suggesteditems)}
                  >
                    <div style={{ color: "#9e9e9e" }}>{suggesteditems}</div>
                  </Tag>
                );
              })
            : null}
        </Col> */}
        <div className="results_descriptiontext" style={{margin:windowDimensions.width < 769?'0 0.8rem 4% 0.8rem':'0 0 2% 0'}} >
            {
            Object.keys(totalCountError).length == 0 &&
            !gqlError  ? (
              //  && props.value?.length
              totalCountLoading ? (
                <div>Showing {<LoadingOutlined className="count-loader" />} items</div>
              ) : (
                <div
                >
                  Showing{" "}
                  {skillListings?.skilllistings?.data?.[0].TotalCount?.count?.total ||0
                      } {" "}
                  items {" "}
                </div>
              )
            ) : null}
        </div>
        {windowDimensions.width < 769
        &&
        <div style={{width:'100%',borderBottom:'1px solid #E4E4E4',marginBottom:'4%'}} />
        }
        <div style={{margin:windowDimensions.width < 769&&'0 0.8rem 4% 0.8rem'}} >
        {
          <>
            {windowDimensions.width > 768 ? (
              <>
                <div className="filters-wrapper-candidate-market">
                  <Space wrap>
                    <Dropdown
                      destroyPopupOnHide={true}
                      overlayClassName="searchResultsFilterDropdown"
                      overlay={JobMenu}
                      trigger="click"
                      visible={closeModalSkill}
                      onOpenChange={() => {
                        setCloseModalSkill(!closeModalSkill);
                        setFilterError("");
                      }}
                    >
                      <Button
                        className={
                          searchFilters.skillListing_type
                            ? "skill-list-type-dropdown-select"
                            : "skill-list-type-dropdown"
                        }
                        onClick={() => {
                          setModal(true);
                          setCloseModalSkill(!closeModalSkill);
                        }}
                      >
                        Skill listing type 
                        <img src={downArrow} 
                        style={{
                          width:'8px',  
                          }}
                          />
                        {/* <FiChevronDown
                        style={{
                          fontSize:'13px',
                          opacity:'70%'
                          }}
                          /> */}
                       
                      </Button>
                    </Dropdown>

                    {/* //country */}
                    <Dropdown
                      overlayClassName="searchResultsFilterDropdown"
                      overlay={StateMenu}
                      trigger="click"
                      visible={closeModalState}
                      onOpenChange={(e) => {
                        handleCountryChange(e);
                        setCloseModalState(!closeModalState);
                        setFilterError("");
                      }}
                    >
                      <Button
                      
                        className={
                          searchFilters.countryId?.length > 0
                            ? "visaStatus-dropdown-select"
                            : "visaStatus-dropdown"
                        }
                        onClick={() => {
                          setCloseModalState(!closeModalState);
                        }}
                      >
                   
                   
                        Country  <img src={downArrow} 
                        style={{
                          width:'8px',  
                          }}
                          />
                        {/* <DownOutlined /> */}
                      </Button>
                    </Dropdown>

                    {/* //state */}
                    <Dropdown
                      overlayClassName="searchResultsFilterDropdown"
                      overlay={RegionMenu}
                      trigger="click"
                      visible={closeModalRegion}
                      onOpenChange={(e) => {
                        handleRegionChange(e);
                        setCloseModalRegion(!closeModalRegion);
                        setFilterError("");
                      }}
                    >
                      <Button
                        className={
                          searchFilters.regionId?.length > 0
                            ? "visaStatus-dropdown-select"
                            : "visaStatus-dropdown"
                        }
                        onClick={() => {
                          setCloseModalRegion(!closeModalRegion);
                        }}
                      >
                        State <img src={downArrow} 
                        style={{
                          width:'8px',  
                          }}
                          />
                      </Button>
                    </Dropdown>

                    {/* //city */}
                    <Dropdown
                      overlayClassName="searchResultsFilterDropdown"
                      overlay={locationMenu}
                      trigger="click"
                      visible={closeModalLoc}
                      onOpenChange={(e) => {
                        handleCityChange(e);
                        setCloseModalLoc(!closeModalLoc);
                        setFilterError("");
                      }}
                    >
                      <Button
                        className={
                          searchFilters?.cityId?.length > 0
                            ? "visaStatus-dropdown-select"
                            : "visaStatus-dropdown"
                        }
                        onClick={() => {
                          setCloseModalLoc(!closeModalLoc);
                        }}
                      >
                        City <img src={downArrow} 
                        style={{
                          width:'8px',  
                          }}
                          />
                      </Button>
                    </Dropdown>

                      <Dropdown
                        destroyPopupOnHide={true}
                        overlayClassName="searchResultsFilterDropdown"
                        overlay={BudgetMenu}
                        trigger="click"
                        visible={closeModalBudget}
                        onOpenChange={() => {
                          setCloseModalBudget(!closeModalBudget);
                          setFilterError("");
                        }}
                      >
                        <Button
                          className={
                            searchFilters.budgetMax && searchFilters.budgetMax
                              ? "visaStatus-dropdown-select"
                              : "visaStatus-dropdown"
                          }
                          onClick={() => {
                            setCloseModalBudget(!closeModalBudget);
                          }}
                        >
                          Budget <img src={downArrow} 
                        style={{
                          width:'8px',  
                          }}
                          />
                        </Button>
                      </Dropdown>                    <Dropdown
                      destroyPopupOnHide={true}
                      overlayClassName="searchResultsFilterDropdown"
                      overlay={experienceLevel}
                      trigger="click"
                      visible={closeModalExp}
                      onOpenChange={() => {
                        setCloseModalExp(!closeModalExp);
                        setFilterError("");
                      }}
                    >
                      <Button
                        className={
                          searchFilters.ExperienceLevel?.length
                            ? "skill-list-type-dropdown-select"
                            : "skill-list-type-dropdown"
                        }
                        onClick={() => {
                          setCloseModalExp(!closeModalExp);
                        }}
                      >
                        Experience level <img src={downArrow} 
                        style={{
                          width:'8px',  
                          }}
                          />
                      </Button>
                    </Dropdown>
                    {/* //Companies */}
                    <Dropdown
                      overlayClassName="searchResultsFilterDropdown"
                      overlay={CompanyMenu}
                      trigger="click"
                      visible={closeModalCompany}
                      onOpenChange={(e) => {
                        // handleCountryChange(e);
                        setCloseModalCompany(!closeModalCompany);
                        setFilterError("");
                      }}
                    >
                      <Button
                        className={
                          searchFilters.company
                            ? "visaStatus-dropdown-select"
                            : "visaStatus-dropdown"
                        }
                        onClick={() => {
                          setCloseModalCompany(!closeModalCompany);
                        }}
                      >

                        Company <img src={downArrow} 
                        style={{
                          width:'8px',  
                          }}
                          />

                      </Button>
                    </Dropdown>

                    {/* //Visa Statuses */}
                    <Dropdown
                      overlayClassName="searchResultsFilterDropdown"
                      overlay={VisaMenu}
                      trigger="click"
                      visible={closeModalVisa}
                      onOpenChange={(e) => {
                        // handleCountryChange(e);
                        setCloseModalVisa(!closeModalVisa);
                        setFilterError("");
                      }}
                    >
                      <Button
                        className={
                          searchFilters?.visa?.length > 0
                            ? "visaStatus-dropdown-select"
                            : "visaStatus-dropdown"
                        }
                        onClick={() => {
                          setCloseModalVisa(!closeModalVisa);
                        }}
                      >
                        Visa Status <DownOutlined />
                      </Button>
                      
                    </Dropdown>

                    {userProfile?.Professions?.ProfessionCode == "IT" ? (
                      <>
                        {/* //Previous Industries */}
                        <Dropdown
                          overlayClassName="searchResultsFilterDropdown"
                          overlay={PrevMenu}
                          trigger="click"
                          visible={closeModalPrev}
                          onOpenChange={(e) => {
                            // handleCountryChange(e);
                            setCloseModalPrev(!closeModalPrev);
                            setFilterError("");
                          }}
                        >
                          <Button
                            className={
                              searchFilters?.industry?.length
                                ? "visaStatus-dropdown-select"
                                : "visaStatus-dropdown"
                            }
                            onClick={() => {
                              setCloseModalPrev(!closeModalPrev);
                            }}
                          >

                            Industry <img src={downArrow} 
                        style={{
                          width:'8px',  
                          }}
                          />

                          </Button>
                        </Dropdown>
                      </>
                    ) : null}
                  </Space>
                  <div className="applied-filter">
                  {/* {searchFilters.ExperienceLevel?.length ? (
                    <Tag
                      closable={true}
                      className="filter-tag"
                      onClose={() => {
                        closeIconHandler("experience");
                        setFilter({ ExperienceLevel: [] });
                        setCheckRadio(null);
                        removeQuery("experience");
                      }}
                    >
                      {searchFilters.ExperienceLevel}
                    </Tag>
                  ) : null} */}

                  <div className="div2-searchResults">
                    <div className="sortText">Sort by</div>
                    <Dropdown
                      overlayClassName="sortByFilterDropdown"
                      overlay={menu}
                      trigger={["click"]}
                      className="dropdown1"
                    >
                      {/* <Button style={{ border: "none" }}>
                      <div className="filterDropDownText">
                        {sortTypeText}
                      </div>
                      <DownOutlined className="dropDownIcon" />
                    </Button> */}
                      <Space style={{ border: "none" }}>
                        <a
                          style={{ border: "none" }}
                          onClick={(e) => e.preventDefault()}
                        >
                          <div className="filterDropDownText">
                            {sortTypeText}
                          </div>
                        </a>
                        <img src={downArrow} 
                        style={{
                          width:'8px',
                          cursor:'pointer' ,
                          marginBottom:'2px' 
                          }}
                          />
                        {/* <FiChevronDown style={{
                          fontSize:'22px',
                       color:'#5e5e5e',
                       marginTop:'7px',
                       cursor:'pointer'}}/> */}
                        {/* <DownOutlined /> */}
                      </Space>
                    </Dropdown>
                  </div>
                </div>
                  {/* <div className="market-previous-nearby-filter-div">
                    <div
                      style={{ width: "100%", marginBottom: "1%" }}
                      onClick={(e) => hidePreviousFunc(e)}
                    >
                      <input
                        style={{ marginLeft: "2%", cursor: "pointer" }}
                        value=""
                        onChange={() => console.log('')}
                        checked={hideCheck ? "true" : ""}
                        type="radio"
                        name="hidePreviouslyViewed"
                      />
                      &nbsp;Hide previously viewed
                    </div>

                    <Row style={{ width: "100%" }}>
                      <div className="location-button">
                        <Switch onChange={mylocation} />
                      </div>
                      <div className="location-text">Nearby candidates</div>
                    </Row>
                  </div> */}
                </div>
                 <div className="applied-filters-div">
                {searchFilters.skillListing_type ? (
                    <Tag
                      closable={true}
                      className="filter-tag"
                      onClose={() => {
                        closeIconHandler("jobType");
                        setFilter({ skillListing_type: null });
                        setJobTypeRadios(null);
                        removeQuery("skillListing_type");
                      }}
                    >
                      {searchFilters.skillListing_type?.replaceAll("+", " ")}
                      {/* {searchFilters.skillListing_type == "Contract"?
                    "Contract"
                    :searchFilters.skillListing_type == "Permanent"?
                  "Permanent"
                  : searchFilters.skillListing_type=="Per+Diem" &&
                  "Per Diem"
                } */}
                    </Tag>
                  ) : null}
                  {searchFilters?.location.length > 0
                    ? searchFilters?.location?.map((res) => {
                        return (
                          <Tag
                            key={res.ids}
                            closable={true}
                            className="filter-tag"
                            onClose={() => {
                              let checkname = res;
                              setSearchFilters({
                                ...searchFilters,
                                location: searchFilters?.location?.filter(
                                  (response) => {
                                    return response.ids != checkname.ids;
                                  }
                                ),
                                cityId: searchFilters?.cityId?.filter(
                                  (response) => {
                                    return response != checkname.ids;
                                  }
                                ),
                              });
                              setCheckRadioLoc(
                                searchFilters?.location?.filter((response) => {
                                  return response?.name != checkname.name;
                                })
                              );
                              setCheckCityId(
                                searchFilters?.cityId.filter((response) => {
                                  return response != checkname.ids;
                                })
                              );
                              if (searchFilters?.cityId?.length > 1) {
                                addQuery(
                                  "City",
                                  JSON.stringify(
                                    searchFilters?.location?.filter(
                                      (response) => {
                                        return response.ids != checkname.ids;
                                      }
                                    )
                                  )
                                );
                                addQuery(
                                  "cityId",
                                  JSON.stringify(
                                    searchFilters?.cityId?.filter(
                                      (response) => {
                                        return response != checkname.ids;
                                      }
                                    )
                                  )
                                );
                              } else {
                                removeQuery("City");
                                removeQuery("cityId");
                              }
                              // setCheckRadioLoc([]);
                              // setCheckLocObject(null);
                              // setCheckCityId([]);
                              // removeQuery("City");
                              // removeQuery("cityId");
                            }}
                          >
                            {res.name.replaceAll("+", " ")}
                          </Tag>
                        );
                      })
                    : null}

                  {/* //Region */}
                  {searchFilters.state?.length > 0
                    ? searchFilters?.state?.map((res) => {
                        return (
                          <Tag
                            key={res.id}
                            closable={true}
                            className="filter-tag"
                            onClose={() => {
                              let checkname = res;
                              setSearchFilters({
                                ...searchFilters,
                                regionId: searchFilters.regionId.filter(
                                  (response) => {
                                    return response.id != checkname.id;
                                  }
                                ),
                                state: searchFilters.state?.filter(
                                  (response) => {
                                    return response?.name != checkname?.name;
                                  }
                                ),
                              });
                              setCheckRadioRegion(
                                searchFilters?.state?.filter((response) => {
                                  return response?.name != checkname.name;
                                })
                              );
                              if (searchFilters.regionId?.length > 1) {
                                addQuery(
                                  "Region",
                                  JSON.stringify(
                                    searchFilters.state?.filter((response) => {
                                      return response.name != checkname?.name;
                                    })
                                  )
                                );
                                addQuery(
                                  "regionId",
                                  JSON.stringify(
                                    searchFilters.regionId.filter(
                                      (response) => {
                                        return response != checkname.id;
                                      }
                                    )
                                  )
                                );
                              } else {
                                removeQuery("Region");
                                removeQuery("regionId");
                              }
                            }}
                          >
                            {res.name.replaceAll("+", " ")}
                          </Tag>
                        );
                      })
                    : null}

                  {/* //state */}
                  {searchFilters.countryId?.length > 0
                    ? searchFilters?.region?.map((res) => {
                        return (
                          <Tag
                            key={res.id}
                            closable={true}
                            className="filter-tag"
                            onClose={() => {
                              let checkname = res;
                              setSearchFilters({
                                ...searchFilters,
                                region: searchFilters.region?.filter(
                                  (response) => {
                                    return response != checkname?.name;
                                  }
                                ),
                                countryId: searchFilters.countryId.filter(
                                  (response) => {
                                    return response != checkname.id;
                                  }
                                ),
                              });
                              setCheckCountryId(
                                searchFilters.countryId.filter((response) => {
                                  return response != checkname.id;
                                })
                              );
                              if (searchFilters.countryId?.length > 1) {
                                addQuery(
                                  "Country",
                                  JSON.stringify(
                                    searchFilters.region?.filter((response) => {
                                      return response != checkname?.name;
                                    })
                                  )
                                );
                                addQuery(
                                  "countryId",
                                  JSON.stringify(
                                    searchFilters.countryId.filter(
                                      (response) => {
                                        return response != checkname.id;
                                      }
                                    )
                                  )
                                );
                              } else {
                                removeQuery("Country");
                                removeQuery("countryId");
                              }
                            }}
                          >
                            {res.name.replaceAll("+", " ")}
                          </Tag>
                        );
                      })
                    : null}

                  {searchFilters.budgetMin && searchFilters.budgetMax ? (
                    <Tag
                      closable={true}
                      className="filter-tag"
                      onClose={() => {
                        closeIconHandler("budget");
                        setFilter({
                          budgetMin: null,
                          budgetMax: null,
                          budgetType: null,
                        });
                        setBudget({
                          budgetMax: null,
                          budgetMin: null,
                          budgetType: null,
                        });
                        setClearForm(true);
                        removeQuery("budgetMax");
                        removeQuery("budgetMin");
                        removeQuery("budgetType");
                      }}
                    >
                      {"$" +
                        searchFilters.budgetMin +
                        " - " +
                        "$" +
                        searchFilters.budgetMax}
                    </Tag>
                  ) : null}
                  {searchFilters?.ExperienceLevel?.length > 0
                    ? searchFilters?.ExperienceLevel?.map((item, index) => {
                        return (
                          <Tag
                            key={Math.random()}
                            closable={true}
                            className="filter-tag"
                            onClose={() => {
                              const res = item;
                              setFilter({
                                ExperienceLevel:
                                  searchFilters?.ExperienceLevel?.filter(
                                    (response) => {
                                      return response != res;
                                    }
                                  ),
                              });

                              setCheckRadio(null);
                              if (checkBox && checkBox?.length > 1) {
                                addQuery(
                                  "experience",
                                  JSON.stringify(
                                    searchFilters?.ExperienceLevel?.filter(
                                      (response) => {
                                        return response != res;
                                      }
                                    )
                                  )
                                );
                              } else {
                                removeQuery("experience");
                              }
                              setCheckedBox((prevCheckbox) =>
                                prevCheckbox.filter((item) => item !== res)
                              );
                              setSearchFilters({
                                ...searchFilters,
                                ExperienceLevel:
                                  searchFilters?.ExperienceLevel?.filter(
                                    (response) => {
                                      return response != res;
                                    }
                                  ),
                              });
                            }}
                          >
                            {item}
                          </Tag>
                        );
                      })
                    : null}
                  {searchFilters?.company ? (
                    <Tag
                      closable={true}
                      className="filter-tag"
                      onClose={() => {
                        setSearchFilters({
                          ...searchFilters,
                          company: null,
                        });
                        setCheckRadioCompany(null);
                        removeQuery("Company");
                      }}
                    >
                      {searchFilters?.company?.replaceAll("+", " ")?.replaceAll("-*",'&')}
                    </Tag>
                  ) : null}
                   {searchFilters.industry?.length > 0
                      ? searchFilters?.industry?.map((res) => {
                          return (
                            <Tag
                              key={res?.id}
                              closable={true}
                              className="tag-filter"
                              onClose={() => {
                                let checkname = res;
                                setSearchFilters({
                                  ...searchFilters,
                                  industry: searchFilters?.industry?.filter(
                                    (response) => {
                                      return response?.name != checkname?.name;
                                    }
                                  ),
                                  industryId: searchFilters?.industryId?.filter(
                                    (response) => {
                                      return response != checkname.id;
                                    }
                                  ),
                                });
                                if (searchFilters?.industryId?.length > 1) {
                                  addQuery(
                                    "Industry",
                                    JSON.stringify(
                                      searchFilters?.industry?.filter(
                                        (response) => {
                                          return response?.name != checkname?.name;
                                        }
                                      )
                                    ),
                                    "replace"
                                  );
                                  addQuery(
                                    "industryId",
                                    JSON.stringify(
                                      searchFilters?.industryId?.filter(
                                        (response) => {
                                          return response != checkname.id;
                                        }
                                      )
                                    ),
                                    "replace"
                                  );
                                } else {
                                  removeQuery("Industry");
                                  removeQuery("industryId");
                                }
                              }}
                            >
                              {res?.name
                                ?.replaceAll("+", " ")
                                ?.replaceAll("-*", "&")}
                            </Tag>
                          );
                        })
                      : null}
                  {/* {searchFilters?.industry ? (
                    <Tag
                      closable={true}
                      className="filter-tag"
                      onClose={() => {
                        setSearchFilters({
                          ...searchFilters,
                          industry: null,
                        });
                        setCheckRadioIndustry(null);
                        removeQuery("Industry");
                      }}
                    >
                      {searchFilters?.industry?.replaceAll("+", " ")?.replaceAll("-*","&")}
                    </Tag>
                  ) : null} */}
                  {searchFilters.visa?.length > 0
                    ? searchFilters?.visaName?.map((res) => {
                        return (
                          <Tag
                            key={res.id}
                            closable={true}
                            className="filter-tag"
                            onClose={() => {
                              let checkname = res;
                              // closeIconHandler("country");
                              setCheckRadioVisaName((prevRadioVisa) =>
                              prevRadioVisa.filter(
                                (item) => item.name?.replaceAll("+", " ") !== res.name?.replaceAll("+", " ")
                              ));
                              // (prevRadioVisa) =>
                              //   prevRadioVisa.filter(
                              //     (item) => item.name !== res.name
                              //   )
                              setSearchFilters({
                                ...searchFilters,
                                visaName: searchFilters?.visaName?.filter(
                                  (response) => {
                                    return response != checkname?.name;
                                  }
                                ),
                                visa: searchFilters?.visa?.filter(
                                  (response) => {
                                    return response != checkname.id;
                                  }
                                ),
                              });
                              if (searchFilters?.visa?.length > 1) {
                                addQuery(
                                  "VisaName",
                                  JSON.stringify(
                                    searchFilters?.visaName?.filter(
                                      (response) => {
                                        return response.id != checkname?.id;
                                      }
                                    )
                                  ),
                                  'replace'
                                );
                                addQuery(
                                  "VisaStatusId",
                                  JSON.stringify(
                                    searchFilters?.visa?.filter(
                                      (response) => {
                                        return response != checkname.id;
                                      }
                                    )
                                  ),
                                  'replace'
                                );
                              } else {
                                removeQuery("VisaName");
                                removeQuery("VisaStatusId");
                              }
                            }}
                          >
                            {res.name?.replaceAll("+", " ")}
                          </Tag>
                        );
                      })
                    : null}
                </div>

                {!props.job_title &&
                skillListings?.skilllistings?.data?.length > 0 ? (
                  <div className="select-all" style={{ marginLeft: "0px" }}>
                    <Checkbox
                      onChange={onCheckAllChange}
                      checked={checkAllClicked}
                    ></Checkbox>
                    <div style={{ paddingLeft: "10px", paddingTop: "0px" }}>
                      {selectText == true ? "Select" : "Deselect"} all skill listings
                    </div>
                  </div>
                ) : null}
              </>
            ) : (
              <>
                <Row
                  style={{
                    justifyContent: "space-between",
                    width: "99%",
                    marginTop: "3px",
                  }}
                >
                  <div
                    className="filter-button1"
                    // sm={11}
                    // xs={11}
                    onClick={() => setVisible(true)}
                  >
                    <img
                      className={"filter-button-icon"}
                      alt=""
                      src={FilterIcon}
                    />
                    <div className={"filter-button-text"}>
                      Filter{" "}
                      <Text>{filterCount > 0 && `(${filterCount})`}</Text>{" "}
                    </div>
                  </div>

                  <div
                    className="filter-button2"
                    // sm={11}
                    // xs={11}
                    onClick={() => setSortVisible(true)}
                  >
                    <img
                      className={"filter-button-icon"}
                      alt=""
                      src={SortIcon}
                    />
                    <div className={"filter-button-text"}>Sort</div>
                  </div>
                </Row>
                <Row
                  style={{
                    marginTop: "18px",
                    paddingLeft: "2px",
                    marginBottom: "8px",
                  }}
                >
                </Row>

                <Drawer
                  placement="top"
                  height={windowDimensions.height}
                  onClose={onCloseFiltersModal}
                  open={visible}
                  closable={false}
                  // title={
                  //   <div>
                  //     <Row>
                  //       <Col
                  //         xs={5}
                  //         className={"clearAll"}
                  //         onClick={clearAllFunction}
                  //       >
                  //         Clear all
                  //       </Col>
                  //       <Col xs={14} className={"filter-text"}>
                  //         Filters
                  //       </Col>
                  //     </Row>
                  //   </div>
                  // }
                  title={
                    <div>
                      <Row>
                        <Col
                          xs={4}
                          className={"clearAll"}
                          style={{ justifyContent: "flex-start" }}
                          onClick={clearAllFunction}
                        >
                          Clear all
                        </Col>
                        <Col xs={18} className={"filter-text"}>
                          Filters
                        </Col>
                        <Col
                          xs={2}
                          style={{ textAlign: "center", cursor: "pointer" }}
                          onClick={onCloseFiltersModal}
                        >
                          <CloseOutlined style={{ color: "#9e9e9e" }} />
                        </Col>
                      </Row>
                    </div>
                  }
                  centered
                  // visible={visible}
                  // onOk={() => setVisible(false)}
                  // onCancel={() => {
                  //   setFilterError("");
                  //   setIsFormOpen(false);
                  //   setVisible(false);
                  // }}
                  width={"100%"}
                  // height={900}
                  footer={[
                    <Button
                      key="back"
                      onClick={() => applyFilters("mobile")}
                      className="modal-button"
                    >
                      Apply filter
                    </Button>,
                  ]}
                >
                  <Filters
                    fromCandMkt={true}
                    prop="prop"
                    setFilter={setFilter}
                    setBudget={setBudget}
                    setClear={setClearForm}
                    budget={budget}
                    checkBox={checkBox}
                    setCheckedBox={setCheckedBox}
                    clear={clearForm} //for budget
                    setcheck={setCheckRadio}
                    check={checkRadio} //for experience level
                    setJobTypeRadios={setJobTypeRadios}
                    jobTypeRadio={jobTypeRadio} //for job type
                    setCheckRadioLoc={setCheckRadioLoc}
                    checkRadioLoc={checkRadioLoc} //for location
                    setCheckRadioRegion={setCheckRadioRegion}
                    checkRadioRegion={checkRadioRegion} //for region
                    setCheckRadioCountry={setCheckRadioCountry}
                    checkRadioCountry={checkRadioCountry} //for state
                    setCheckCityId={setCheckCityId}
                    checkCityId={checkCityId}

                    //for company filter
                    setcheckCompany={setCheckRadioCompany}
                    checkCompany={checkRadioCompany}
                    setFilterCompany={setFilter}
                    addQueryCompany={addQuery}
                    emptyCompanyInput={emptyCompanyInput}
                    setEmptyCompanyInput={setEmptyCompanyInput}
                    //for company filter
                    
                    //for visa statuses
                    setCheckVisa={setCheckRadioVisa}
                    checkVisa={checkRadioVisa}
                    setCheckVisaIdArray={setCheckVisaIdArray}
                    checkVisaIdArray = {checkVisaIdArray}
                    //for visa statuses

                    //for industry
                    setIndustryRadioCheck={setCheckRadioIndustry}
                    industryRadioCheck={checkRadioIndustry}
                    setEmptyIndustryInput={setEmptyIndustryInput}
                    emptyIndustryInput={emptyIndustryInput}
                    setEmptyPrevIndustryInput={setEmptyPrevIndustryInput}
                    emptyPrevIndustryInput={emptyPrevIndustryInput}
                    setIndustryObj={setCheckIndustryObject}
                    industryObj={checkIndustryObject}
                    setCheckIndustryId={setCheckIndustryId}
                    checkIndustryId={checkIndustryId}
                    //for industryx

                    searchLocationFilter={searchLocationFilter}
                    setCheckRegionId={setCheckRegionId}
                    checkRegionId={checkRegionId}
                    setCheckCountryId={setCheckCountryId}
                    checkCountryId={checkCountryId}
                    setlocObj={setCheckLocObject}
                    locObj={checkLocObject}
                    setregionObj={setCheckRegionObject}
                    regionObj={checkRegionObject}
                    setcountryObj={setCheckCountryObject}
                    countryObj={checkCountryObject}
                    authToken={authToken}
                    hideCheck={hideCheck}
                    setHideCheck={setHideCheck}
                    searchFilters={searchFilters}
                    setSearchFilters={setSearchFilters}
                    addQuery={addQuery}
                    removeQuery={removeQuery}
                    emptyCityInput={emptyCityInput}
                    emptyRegionInput={emptyRegionInput}
                    emptyCountryInput={emptyCountryInput}
                    setEmptyCityInput={setEmptyCityInput}
                    setEmptyRegionInput={setEmptyRegionInput}
                    setEmptyCountryInput={setEmptyCountryInput}
                  />
                  {checkFiltervalidity() && (
                    <div className="filter-error-style">
                      Please select any filter
                    </div>
                  )}
                </Drawer>

                {/* Modal for sort */}
                <Drawer
                  placement="top"
                  height="540px"
                  onClose={onCloseSortModal}
                  open={sortvisible}
                  closable={false}
                  title={
                    <div>
                      <Row>
                        <Col xs={22} style={{ textAlign: "left" }}>
                          Sort candidates by
                        </Col>
                        <Col
                          xs={2}
                          style={{ textAlign: "center", cursor: "pointer" }}
                          onClick={onCloseSortModal}
                        >
                          <CloseOutlined style={{ color: "#9e9e9e" }} />
                        </Col>
                      </Row>
                    </div>
                  }
                  // title="Sort Candidates by"
                  // centered
                  // visible={sortvisible}
                  // onOk={() => setSortVisible(false)}
                  // onCancel={() => setSortVisible(false)}
                  width={"100%"}
                  // height={1000}
                  footer={[
                    <Button
                      disabled={sort?.target?.value ? false : true}
                      key="back"
                      className="modal-button"
                      onClick={SortResults}
                    >
                      Show results
                    </Button>,
                  ]}
                >
                  <Filters setSort={setSort} selectedOption={sortType} />
                </Drawer>

                {!props.job_title &&
                skillListings?.skilllistings?.data?.length > 0 ? (
                  <Col className="select-all">
                    <Checkbox
                      onChange={onCheckAllChange}
                      checked={checkAllClicked}
                    ></Checkbox>
                    <Col style={{ paddingLeft: "10px", paddingTop: "1px" }}>
                      {selectText == true ? "Select" : "Deselect"} all skill listings 
                    </Col>
                  </Col>
                ) : null}
              </>
            )}
          </>
        }

        <div
        // className={`${Count?.result?.aggregate?.totalCount  && "search-skillListings-div"} `}
        >
          {/* props.value.length == 0 */}
          {
            <div
              className={`${
                skillListings?.skilllistings?.data?.length > 0
                  ? "gqll-receivedSkills"
                  : ""
              } 
              ${
                skillListings?.skilllistings?.data?.length <= 3 &&
                skillListings?.skilllistings?.data?.length > 1 &&
                windowDimensions.width > 768
                  ? "threeorless"
                  : ""
              } ${
                skillListings?.skilllistings?.data?.length == 1
                //  &&
                // windowDimensions.width < 768
                  ? "onlyone"
                  : ""
              }`}
              pagination={"true"}
            >
              {gqlError  //|| Object.keys(totalCountError).length > 0 
              ? (
                <div className="noJobsContainer">
                  <img
                    src={emptyresult}
                    alt="no-jobsimg"
                    className="joblisting-noimg"
                    style={{ width: "15rem", height: "9.3rem" }}
                  ></img>
                  <>
                    <div>
                      <p className="NoResultText"> Something went wrong</p>
                      <p className="NoResultText2">Please Try again</p>
                    </div>
                  </>
                </div>
              ) : skillListings?.skilllistings?.data?.length === 0 ? (
                <div className="noJobsContainer">
                  <img
                    src={emptyresult}
                    alt="no-jobsimg"
                    className="joblisting-noimg"
                    style={{ width: "15rem", height: "9.3rem" }}
                  ></img>
                  <>
                    <div>
                      <p className="NoResultText">
                        {" "}
                        No results found For your search{" "}
                      </p>
                      <p className="NoResultText2">
                        Try searching something else
                      </p>
                    </div>
                  </>
                </div>
              ) : skillListings && skillListings?.skilllistings ? (
                skillListings?.skilllistings.data?.map((data, index) => {
                  return (
                    <GigsCard
                    key={index}
                      {...data}
                      all_data = {skillListings?.skilllistings.data}
                      searchType="Skills"
                      // checkboxMargin={Count?.result?.aggregate?.totalCount == 0?'4px': "-0.9rem"}
                      // eyeMargin={countLoading? null: '-0.9rem'}
                      // lineheight={0.5}
                      // marginTop={5}
                      currentPage={currentPage}
                      marginTop={2}
                      token={authToken}
                      dataList={userDataList}
                      setDataList={setUserDataList}
                      setCandidateId={setCandidateId}
                      setcheckAllClicked={setcheckAllClicked}
                      setSkillListingIds={setSkillListingIds}
                      localStorageKey = {'SelectedSkills'}
                      setLocalStorage={setLocalStorage}
                      skillListingIds={skillListingIds}
                      findMatch={props.job_title && true}
                      job_title={props.job_title}
                      job_id={props.job_id}
                    />
                  );
                })
              ) : (
                <div className="gql-loader">
                  {/* {props.value.length > 0 && props.loading && <LoadingOutlined />} */}
                  <LoadingOutlined />
                </div>
              )}
              {/* {
                skillListings?.skilllistings?.data?.length === 0 &&
                (
                  <>
                    <div style={{ width: '50%', margin: 'auto', textAlign: 'center', marginTop: '10%' }}>
                      No Results Found For Your Search <br />
                      <span>Try searching something else</span>
                    </div>
                  </>
                )
              } */}
            </div>
          }

          {/* {props.value.length > 0 && loading ? (
            <>
              <div className="gql-loader"> 
                <LoadingOutlined />
                 
              </div>
            </>
          ) :
           null} */}

          {/* {props.value.length > 0 &&
            !loading &&
            skillListings?.skilllistings?.data?.length === 0 ? (
            <div className="gql-receivedGigs">
              <div className="gql-message">No gigs found!</div>
            </div>
          ) : null} */}
        </div>

        {windowDimensions.width < 769 &&
        authToken != null &&
        skillListingIds?.length > 0 ? (
          <div className="multi-bid-btn-div">
            {/* <Button className={"multi-bids-btn"} onClick={placeBid}> */}
            <Button className={"btn-multi-bids"} onClick={placeBid}>
              <Text className="multi-bids-btn-text">
                Place a bid{" "}
                {skillListingIds?.length > 0
                  ? `( ${skillListingIds?.length} Skill ${skillListingIds?.length > 1 ? 'listings' : 'listing'} )`
                  : null}
              </Text>
            </Button>
            <Button
               className="mobile-cancel-bid-button-cd-market" 
              //  className="mobile-cancel-bid-button" 
               onClick={cancelBid}>
                Cancel
              </Button>
          </div>
        ) : (
          skillListingIds?.length > 0 && (
            <div className="btn-multi-div">
              <button className={"btn-multi-bids"} onClick={placeBid}>
                Place a bid{" "}
                {skillListingIds?.length > 0
                  ? `( ${skillListingIds?.length} Skill ${skillListingIds?.length > 1 ? 'listings' : 'listing'} )`
                  : null}
              </button>

              <button className="desktop-cancel-bid-button" onClick={cancelBid}>
                Cancel
              </button>
            </div>
          )
        )}
        
        {skillListings?.skilllistings && !gqlError  //&&  Object.keys(totalCountError).length == 0 
        ? (
          windowDimensions.width > 769 ? (
            <div style={{ margin: "auto", marginTop: "30px", display:'flex', justifyContent:'center' }}>
              <Pagination
                total={
                  skillListings?.skilllistings?.data.length > 0 &&
                  skillListings?.skilllistings?.data?.[0].TotalCount?.count
                  ? skillListings?.skilllistings?.data?.[0].TotalCount?.count?.total
                  : ''
                }
                pageSize={perPage}
                defaultCurrent={1}
                current={currentPage}
                // onChange={(page) => setPageNo(page)}
                onChange={(page, pageSize) => onChangePage(page, pageSize)}
                // pageSizeOptions={[12, 20]}
                hideOnSinglePage={true}
                showSizeChanger={false}
              />
            </div>
          ) : (
            <div>
              <MobilePagination
                span={24}
                current={currentPage}
                defaultPageSize={20}
                total={
                  skillListings?.skilllistings?.data.length > 0 &&
                  skillListings?.skilllistings?.data[0].TotalCount?.count
                  ? skillListings?.skilllistings?.data[0].TotalCount?.count?.total
                  : ''
                  
                  // totalCount?.result?.aggregate?.totalCount
                  //   ? totalCount?.result?.aggregate?.totalCount
                  //   : ""
                }
              
                onChange={(page) => onChangePage(page, 20)}
              />
            </div>
          )
        ) : null}
        </div>
      </main>
      </> : null }
      <PlaceBidModal
        visible={placebidModal}
        setHidePagePvt={setHidePagePvt}
        placeBidModalVisisblityHandler={placeBidModalVisisblityHandler}
        selectedCandidates={candidateList}
        setSelectedCandidates={setcandidateList}
        // desired_rate={Pdetails?.skill_listings?.MinimumBid}
        multiBid={true}
        setSkillListingIds={setSkillListingIds}
        setcheckAllClicked={setcheckAllClicked}
      />
      {/* </div> */}
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    loading: state.searchCandidateMarketReducer.loading,
    skillListings: state.searchCandidateMarketReducer.skillListings,
    value: state.searchCandidateMarketReducer.searchvalue,
    error: state.searchCandidateMarketReducer,
    token: state.authReducer.user?.authToken,
    authToken: state.authReducer.user.authToken,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    SearchResponseRequested: (params) => {
      dispatch(SearchResponseRequested(params)); // action dispatched
    },
    searchResponse: (params) => {
      dispatch(SearchResponse(params)); // action dispatched
    },
    searchValue: (params) => {
      dispatch(SearchValue(params)); // action dispatched
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Search_Results);
